exports.QUESTIONS = [
  {
    qid: 73,
    qowner: 'Richard',
    qkey: 'Double01',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: '4+ clubs',
    qbad2: 'Heart stopper',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgeBum']
  },
  {
    qid: 74,
    qowner: 'Richard',
    qkey: 'Double02',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: 'Penalty double',
    qbad2: 'Asking for a club stopper',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgeBum']
  },
  {
    qid: 75,
    qowner: 'Richard',
    qkey: 'Double03',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: 'Penalty double',
    qbad2: 'Takeout, has 4 spades',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgeBum']
  },
  {
    qid: 76,
    qowner: 'Richard',
    qkey: 'Double04',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: 'Take out, has clubs and diamonds',
    qbad2: 'Penalty, subsequent doubles are also penalty',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgeBum']
  },
  {
    qid: 77,
    qowner: 'Richard',
    qkey: 'Double05',
    qdetail: 'How many hearts does opener have ?',
    qcorrect: 'Less than 3 hearts',
    qbad1: '3 or fewer',
    qbad2: 'Undetermined',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportLarryCohen']
  },
  {
    qid: 78,
    qowner: 'Richard',
    qkey: 'Double06',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Penalty Double',
    qbad1: '3 card support of partners suit',
    qbad2: 'Takeout, has diamonds and hearts',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportLarryCohen']
  },
  {
    qid: 79,
    qowner: 'Richard',
    qkey: 'Double07',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: '5+ Diamonds, 4 clubs',
    qbad2: 'Penalty, subsequent doubles are also penalty',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportLarryCohen']
  },
  {
    qid: 80,
    qowner: 'Richard',
    qkey: 'Double08',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit & extra values',
    qbad1: 'Penalty double',
    qbad2: 'Take out',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportLarryCohen']
  },
  {
    qid: 81,
    qowner: 'Richard',
    qkey: 'Double09',
    qdetail: 'What does the double mean ?',
    qcorrect: '3 card support of partners suit',
    qbad1: 'Penalty, has clubs',
    qbad2: 'Flat 10+ HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportLarryCohen']
  },
  {
    qid: 82,
    qowner: 'Richard',
    qkey: 'Double10',
    qdetail: 'What does the double mean ?',
    qcorrect: '4H+, 4S+, 6+ points',
    qbad1: 'At least one 4+ card major and a 3+ card',
    qbad2: 'Shows NO stopper in Diamonds, 6-9 HCP, no 4 card major',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 83,
    qowner: 'Richard',
    qkey: 'Double11',
    qdetail: 'What does the double mean ?',
    qcorrect: '4C+, 4D+, 6+ points',
    qbad1: 'Support double of Hearts',
    qbad2: 'Has both Minors and 10+ HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 84,
    qowner: 'Richard',
    qkey: 'Double12',
    qdetail: 'What does the double mean ?',
    qcorrect: 'At least one 4 card major',
    qbad1: 'Both Majors, 4+ cards',
    qbad2: '10+ HCP, no diamond support',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 85,
    qowner: 'Richard',
    qkey: 'Double13',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 4S (sometimes 3), 11-14 HCP',
    qbad1: 'Exactly 3 spades support',
    qbad2: 'Exactly 4 card spades support',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 86,
    qowner: 'Richard',
    qkey: 'Double14',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 4S, 15-16 HCP',
    qbad1: 'Pre-empt, 4 card spades and 11-14 HCP',
    qbad2: 'Pre-empt, 3 card spades and 11-14 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 87,
    qowner: 'Richard',
    qkey: 'Double15',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 4S, 17-18 HCP',
    qbad1: 'Pre-empt, 4 card spades and 11-14 HCP',
    qbad2: '4 card spades and 15-16 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 88,
    qowner: 'Richard',
    qkey: 'Double16',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 4S, 19-21 HCP',
    qbad1: '4 card spades and 15-16 HCP',
    qbad2: '4 card spades and 17-18 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 89,
    qowner: 'Richard',
    qkey: 'Double17',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener <4H, Spade stopper, 12-14 HCP',
    qbad1: 'Weak, <3 hearts',
    qbad2: 'Opener <4 Hearts, 12-14 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 90,
    qowner: 'Richard',
    qkey: 'Double18',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener <4H, Spade stopper, 18-19 HCP',
    qbad1: 'Opener <3H, Spade stopper, 16+ HCP',
    qbad2: 'Opener <4H, Spade stopper, 15-17 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 91,
    qowner: 'Richard',
    qkey: 'Double19',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 6C+, 11-15 HCP',
    qbad1: 'Opener has no spade stopper, 5+ clubs',
    qbad2: 'Opener has 5+ clubs, <4H, <4D',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 92,
    qowner: 'Richard',
    qkey: 'Double20',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Opener 6C+, 16-19 HCP',
    qbad1: 'Opener has 7C+, 11-14 HCP',
    qbad2: 'Opener has 6C+,  <3H, <3S',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 93,
    qowner: 'Richard',
    qkey: 'Double21',
    qdetail: 'What does the double mean ?',
    qcorrect: '16+ HCP, 3S',
    qbad1: 'Exactly 3 spades support',
    qbad2: '16+ HCP, 4S',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleNegativeBridgeBum']
  },
  {
    qid: 94,
    qowner: 'Richard',
    qkey: 'Double22',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Take-out.  Asks partner to bid Clubs, Hearts or Spades',
    qbad1: 'Penalty.  16+ HCP',
    qbad2: 'Take-out.  Has both majors',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleTakeoutBridgeBum']
  },
  {
    qid: 95,
    qowner: 'Richard',
    qkey: 'Double23',
    qdetail: 'What does the double mean ?',
    qcorrect: '1S shows 5S+,  16+ HCP',
    qbad1: '1S shows no support for Hearts, weak',
    qbad2: '1S shows 4S and 3H, weak',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleTakeoutBridgeBum']
  },
  {
    qid: 96,
    qowner: 'Richard',
    qkey: 'Double24',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Takout double',
    qbad1: 'Penalty double',
    qbad2: '4 Hearts, 3+ of other suots',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleAndrewRobson']
  },
  {
    qid: 97,
    qowner: 'Richard',
    qkey: 'Double25',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Penalty Double',
    qbad1: 'Take Out Double',
    qbad2: 'Lead directing double',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleAndrewRobson']
  },
  {
    qid: 98,
    qowner: 'Richard',
    qkey: 'Double26',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Penalty Double',
    qbad1: 'Take Out Double',
    qbad2: 'Snapdragon Double',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleAndrewRobson']
  },
  {
    qid: 99,
    qowner: 'Richard',
    qkey: 'Double27',
    qdetail: 'What does the double mean ?',
    qcorrect: 'Takout double',
    qbad1: 'Penalty Double',
    qbad2: '2 suiter 5/5',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleAndrewRobson']
  },
  {
    qid: 100,
    qowner: 'Richard',
    qkey: 'Double28',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Penalty Double',
    qbad1: 'Takout double',
    qbad2: 'Lead directing double',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleAndrewRobson']
  },
  {
    qid: 101,
    qowner: 'Richard',
    qkey: 'Double29',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Responsive Double.  Showing 4+ in the Majors',
    qbad1: 'Take Out, Flat hand at least 3 in each suit.  You choose partner',
    qbad2: 'Penalty, 10+ HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgebum']
  },
  {
    qid: 102,
    qowner: 'Richard',
    qkey: 'Double30',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Responsive Double.  Showing 4+ in the Minors',
    qbad1: 'Take Out, Flat hand at least 3 in each suit.  You choose partner',
    qbad2: '4 Spades',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgebum']
  },
  {
    qid: 103,
    qowner: 'Richard',
    qkey: 'Double31',
    qdetail: 'What do you bid ?',
    qcorrect: '2S .  Support partner',
    qbad1: 'X.  Take-out double for the other 3 suits',
    qbad2: 'X.  Responsive double showing the minors',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgebum']
  },
  {
    qid: 104,
    qowner: 'Richard',
    qkey: 'Double32',
    qdetail: 'How many HCP are required for a responsive double ? ',
    qcorrect:
      '6+ points at the 2-level, 8+ points at the 3-level, 10+ points at the 4-level',
    qbad1: 'No Minimum Level',
    qbad2:
      '10+ points at the 2-level, 12+ points at the 3-level, 14+ points at the 4-level',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgebum']
  },
  {
    qid: 105,
    qowner: 'Richard',
    qkey: 'Double33',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Denying heart support but promising both minors',
    qbad1: '3 card support of partners suit',
    qbad2: '10+ HCP, flat hand',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgebum']
  },
  {
    qid: 106,
    qowner: 'Richard',
    qkey: 'Double34',
    qdetail: 'Which is a responsive Double ?',
    qcorrect: '1H  X  2H  X',
    qbad1: '1C  X  1S  X',
    qbad2: '1C  2S  3C  X',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgeguys']
  },
  {
    qid: 107,
    qowner: 'Richard',
    qkey: 'Double35',
    qdetail: 'What should you bid ?',
    qcorrect: '2H',
    qbad1: 'Double',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgeguys']
  },
  {
    qid: 108,
    qowner: 'Richard',
    qkey: 'Double36',
    qdetail: 'What should you bid ?',
    qcorrect: 'Responsive double showing the minors',
    qbad1: 'Support double showing 3 spades',
    qbad2: 'Pass, too weak',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgeguys']
  },
  {
    qid: 109,
    qowner: 'Richard',
    qkey: 'Double37',
    qdetail: 'What should you bid ?',
    qcorrect: '3D Cue bid showing BOTH Majors',
    qbad1: 'Responsive Double showing BOTH majors',
    qbad2: '2S planning to bid 3/4H next bid',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgeguys']
  },
  {
    qid: 110,
    qowner: 'Richard',
    qkey: 'Double38',
    qdetail: 'What should you bid ?',
    qcorrect: 'Double showing the other two suits',
    qbad1: '3H  Always bid the Major first',
    qbad2: '4C  Always bid the longest suit',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleResponsiveBridgeguys']
  },
  {
    qid: 111,
    qowner: 'Richard',
    qkey: 'Double39',
    qdetail: 'What should you bid ?',
    qcorrect: 'Double',
    qbad1: 'Pass',
    qbad2: '7D',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleLightnerBridgebum']
  },
  {
    qid: 112,
    qowner: 'Richard',
    qkey: 'Double40',
    qdetail: 'What should you bid ?',
    qcorrect: 'Double',
    qbad1: 'Pass',
    qbad2: '7C',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleLightnerBridgebum']
  },
  {
    qid: 113,
    qowner: 'Richard',
    qkey: 'Double41',
    qdetail: 'What should you bid ?',
    qcorrect: 'Double',
    qbad1: 'Pass',
    qbad2: '7C',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleLightnerBridgebum']
  },
  {
    qid: 114,
    qowner: 'Richard',
    qkey: 'Double51',
    qdetail: 'What should you bid ?',
    qcorrect: 'Pass',
    qbad1: '2NT',
    qbad2: 'Double',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleReopening']
  },
  {
    qid: 115,
    qowner: 'Richard',
    qkey: 'Double52',
    qdetail: 'What should you bid ?',
    qcorrect: '2H',
    qbad1: 'Pass',
    qbad2: 'Double',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleReopening']
  },
  {
    qid: 116,
    qowner: 'Richard',
    qkey: 'Double53',
    qdetail: 'What should you bid ?',
    qcorrect: 'Double',
    qbad1: '2H',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleReopening']
  },
  {
    qid: 117,
    qowner: 'Richard',
    qkey: 'Double54',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Simple raise, can be pre-emptive 3-9 HCP',
    qbad1: 'Simple raise, 2 Spades, pre-emptive',
    qbad2: 'Bergen Raise.  3 Spades 6-9 HCP',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 118,
    qowner: 'Richard',
    qkey: 'Double55',
    qdetail: 'What is a Support Double ?',
    qcorrect:
      'Opener shows EXACTLY 3 card support of Responders suit after opposition interference',
    qbad1:
      'Opener/Responder shows EXACTLY 3 card support of Responders/Openers suit after opposition interference',
    qbad2:
      'Opener shows 3 or MORE card support of Responders suit after opposition interference',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 119,
    qowner: 'Richard',
    qkey: 'Double56',
    qdetail: 'What is a Negative Double ?',
    qcorrect:
      'Responder shows 6+ HCP and at least one 4 card suit in the unbid suits, usually the Major',
    qbad1: 'Responder shows EXACTLY 4 cards in the unbid major',
    qbad2: 'Responder shows 10+ HCP and at least 3 cards in the unbid suits',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 120,
    qowner: 'Richard',
    qkey: 'Double57',
    qdetail: 'What is a Takeout Double?',
    qcorrect:
      'The takeout double is a double by OPENER that asks partner to bid one of the unbid suits. The double usually shows 11+ points and 3+ cards in each unbid suit.',
    qbad1:
      'The takeout double is a double by OPENER or RESPONDER that asks partner to bid one of the unbid suits.',
    qbad2:
      'A takeout double is by Opener when there is interference by opposition',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 121,
    qowner: 'Richard',
    qkey: 'Double58',
    qdetail: 'What is a Responsive Double?',
    qcorrect:
      'A Responsive double is used after partner makes a takeout double to show 4-4 shape in the Minor or Major suits',
    qbad1:
      'A Responsive double is used after partner makes a takeout double to show at least 3 cards in each of the unbid suits',
    qbad2:
      'A Responsive double is used after partner passes to show at least 3 cards in each of the unbid suits',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 122,
    qowner: 'Richard',
    qkey: 'Double59',
    qdetail: 'A Lightner Double is ?',
    qcorrect:
      'A Lead-directing double asking parter to make an unusual lead, and NOT to lead any suit bid on our side',
    qbad1: 'A Lead-directing double asking parter to lead TRUMPS',
    qbad2:
      'A penalty double when the opponents are in Slam asking partner to lead any Ace or King he has',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 123,
    qowner: 'Richard',
    qkey: 'Double62',
    qdetail: 'What is a Reopening Double ?',
    qcorrect:
      'A double to protect against partner having the opponents suit.  No extra values promised, but no more than two cards in the overcallers suit.',
    qbad1: 'A double promising extra values in pass out seat',
    qbad2: 'A double promising a shortage in overcallers suit and extra values',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleSupportBridgebum']
  },
  {
    qid: 124,
    qowner: 'Richard',
    qkey: 'Double63',
    qdetail: 'What does the double mean ?',
    qcorrect:
      'Lead directing, partner has Clubs - At least a 5 card suit with 3 of the top 5 honours',
    qbad1: 'Penalty, partner has both Majors',
    qbad2:
      'Lead directing, partner has a strong hand and at least AKJ in clubs',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleLeadDirecting']
  },
  {
    qid: 125,
    qowner: 'Richard',
    qkey: 'Double64',
    qdetail:
      'A Lead directing double is ?.  What does this bidding sequence mean ?',
    qcorrect:
      'A double asking partner to lead a certain suit which opponents have bid when they end up in the final contract',
    qbad1:
      'A double demanding a certain suit is lead as opening lead.  Partner is not allowed to lead any alternative',
    qbad2:
      'A double to show length in a suit and asking partner to sacrifice on their bid if they have support',
    qbad3: null,
    qgroup1: 'Doubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['DoubleLeadDirecting']
  },
  {
    qid: 126,
    qowner: 'public',
    qkey: 'Redouble01',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect:
      'VALUES Responder Redouble.  10+ HCP, subsequent doubles are penalty',
    qbad1: 'SUPPORT Double, 3 card fit, 6 + HCP',
    qbad2: 'RESCUE re-double (SOS)',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 127,
    qowner: 'public',
    qkey: 'Redouble02',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect:
      'VALUES Responder Redouble.  10+ HCP, subsequent doubles are penalty',
    qbad1: 'SNAPDRAGON re-double',
    qbad2: 'RESCUE re-double (SOS)',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 128,
    qowner: 'public',
    qkey: 'Redouble03',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect:
      "SUPPORT re-double.  3 card support of partners suit, after partner's 1 of a major",
    qbad1: 'GAME FORCE re-double',
    qbad2: 'TAKE-OUT re-double',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 129,
    qowner: 'public',
    qkey: 'Redouble04',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'VALUES redouble from opener',
    qbad1: 'SUPPORT re-double.  3 card support of partners suit, 1 of a major',
    qbad2: 'RESCUE re-double (SOS)',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 130,
    qowner: 'public',
    qkey: 'Redouble05',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'RESCUE re-double (SOS)',
    qbad1: 'SUPPORT Double, 3 card fit, 6 + HCP',
    qbad2: 'SUPPORT 4 card fit for clubs',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 131,
    qowner: 'public',
    qkey: 'Redouble06',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'Bid lowest 4 card suit, try to escape 1NT XX',
    qbad1: 'HELVIC Wriggle',
    qbad2: 'PENALTY double',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 132,
    qowner: 'public',
    qkey: 'Redouble07',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'PENALTY, To play, subsequent doubles penalty',
    qbad1: 'SLAM INVITATION, responder has a big hand',
    qbad2: 'TAKE-OUT responder wants you to bid your best suit',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 133,
    qowner: 'public',
    qkey: 'Redouble08',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'PENALTY, To play, subsequent doubles penalty',
    qbad1: 'TAKE OUT, responder is looking for 3NT',
    qbad2: 'TAKE-OUT responder wants you to bid your best suit',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 134,
    qowner: 'public',
    qkey: 'Redouble09',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'PENALTY, To play, subsequent doubles penalty',
    qbad1: 'TAKE OUT, responder is looking for 3NT',
    qbad2: 'TAKE-OUT responder wants you to bid your best suit',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 135,
    qowner: 'public',
    qkey: 'Redouble10',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'PENALTY, To play, subsequent doubles penalty',
    qbad1: 'TAKE OUT, opener has no stops in clubs',
    qbad2: 'Opener has extra spade length but is weak',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 136,
    qowner: 'public',
    qkey: 'Redouble11',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: "CAN'T PENALTY.  Opener has no defensive tricks.",
    qbad1: 'TRAP PASS - Opener is waiting for responder to double',
    qbad2: 'Opener likes clubs and wishes to defend',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 137,
    qowner: 'public',
    qkey: 'Redouble12',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'PENALTY.  Responder has values to defeat contract',
    qbad1: 'TAKE OUT.  Responder is two suited in the minors',
    qbad2: 'STOPPER ASK - Responder is looking to play in 3NT',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 138,
    qowner: 'public',
    qkey: 'Redouble13',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'TO PLAY in 2C',
    qbad1: 'I have BOTH majors, you choose, game force',
    qbad2:
      'I have NEITHER major, you choose what to do.  I will pass your response.',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 139,
    qowner: 'public',
    qkey: 'Redouble14',
    qdetail:
      'We are looking to bid 3NT with a cue bid of their suit at the 3 level as a stopper ask.  They double and we redouble.  For 3X  X  XX.  What does this bidding sequence mean ?',
    qcorrect: 'I have a partial stopper',
    qbad1: 'I have 1 stopper',
    qbad2: 'I have 2 stoppers',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 140,
    qowner: 'public',
    qkey: 'Redouble15',
    qdetail:
      'We are looking to bid 3NT with a cue bid of their suit at the 3 level as a stopper ask.  They double and we bid 3NT.  What does this bidding sequence mean ?',
    qcorrect: 'I have a 1+ stoppers',
    qbad1: 'I have exactly 1 stopper',
    qbad2: 'I have exactly 2 stoppers',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 141,
    qowner: 'public',
    qkey: 'Redouble16',
    qdetail: 'What does this bidding sequence mean ?',
    qcorrect: 'First round control in Spades, Ace/Void in bid suit',
    qbad1: 'King of Spades',
    qbad2: 'Asking for a stopper to get to 3NT',
    qbad3: null,
    qgroup1: 'Redoubles',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['RedoublesPeteHollands']
  },
  {
    qid: 142,
    qowner: 'Richard',
    qkey: 'PS01',
    qdetail: 'What do you bid ?',
    qcorrect: '1C',
    qbad1: 'Pass',
    qbad2: '3C',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 143,
    qowner: 'Richard',
    qkey: 'PS02',
    qdetail: 'What do you bid ?',
    qcorrect: '3C',
    qbad1: 'Pass',
    qbad2: '1C',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 144,
    qowner: 'Richard',
    qkey: 'PS03',
    qdetail: 'What do you bid ?',
    qcorrect: '1C',
    qbad1: '1D',
    qbad2: '1NT',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 145,
    qowner: 'Richard',
    qkey: 'PS04',
    qdetail: 'What do you bid ?',
    qcorrect: '2H',
    qbad1: '2D',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 146,
    qowner: 'Richard',
    qkey: 'PS05',
    qdetail: 'What do you bid ?',
    qcorrect: '2D',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 147,
    qowner: 'Richard',
    qkey: 'PS06',
    qdetail: 'What do you bid ?',
    qcorrect: '3S',
    qbad1: '2S',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 148,
    qowner: 'Richard',
    qkey: 'PS07',
    qdetail: 'What do you bid ?',
    qcorrect: 'Redouble',
    qbad1: '2C',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 149,
    qowner: 'Richard',
    qkey: 'PS08',
    qdetail: 'What do you bid ?',
    qcorrect: '3D',
    qbad1: '2NT',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 150,
    qowner: 'Richard',
    qkey: 'PS09',
    qdetail: 'What do you bid ?',
    qcorrect: '3NT',
    qbad1: '2S',
    qbad2: '4C',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 151,
    qowner: 'Richard',
    qkey: 'PS10',
    qdetail: 'What do you bid ?',
    qcorrect: '2C',
    qbad1: 'Pass',
    qbad2: '2D',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 152,
    qowner: 'Richard',
    qkey: 'PS11',
    qdetail: 'What do you bid ?',
    qcorrect: '2D',
    qbad1: 'Pass',
    qbad2: 'Double',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 153,
    qowner: 'Richard',
    qkey: 'PS12',
    qdetail: 'What do you bid ?',
    qcorrect: 'Double',
    qbad1: '2D',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 154,
    qowner: 'Richard',
    qkey: 'PS13',
    qdetail: 'What do you bid ?',
    qcorrect: '1H',
    qbad1: 'Double',
    qbad2: '1NT',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 155,
    qowner: 'Richard',
    qkey: 'PS14',
    qdetail: 'What do you bid ?',
    qcorrect: 'Double',
    qbad1: '2C',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 156,
    qowner: 'Richard',
    qkey: 'PS15',
    qdetail: 'What do you bid ?',
    qcorrect: '1S',
    qbad1: '1NT',
    qbad2: 'Double',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 157,
    qowner: 'Richard',
    qkey: 'PS16',
    qdetail: 'What do you bid ?',
    qcorrect: 'Double',
    qbad1: '1NT',
    qbad2: '1D',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 158,
    qowner: 'Richard',
    qkey: 'PS17',
    qdetail: 'What do you bid ?',
    qcorrect: '2S',
    qbad1: '1S',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 159,
    qowner: 'Richard',
    qkey: 'PS18',
    qdetail: 'What do you bid ?',
    qcorrect: 'Double',
    qbad1: 'Pass',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 160,
    qowner: 'Richard',
    qkey: 'PS19',
    qdetail: 'What do you bid ?',
    qcorrect: '4S',
    qbad1: 'Double',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Points Schmoints',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: null
  },
  {
    qid: 186,
    qowner: 'Richard',
    qkey: 'WBF01',
    qdetail:
      'https://www.youtube.com/watch?v=XFTnsOm2Xq4&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=76',
    qcorrect: 'Pass',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: '2D',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF01']
  },
  {
    qid: 187,
    qowner: 'Richard',
    qkey: 'WBF02',
    qdetail:
      'https://www.youtube.com/watch?v=TsZvW9-Imtc&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=74',
    qcorrect: 'Cross Ruff after cashing aces',
    qbad1: 'Cross Ruff immediately',
    qbad2: 'Draw trumps, then cash Aces',
    qbad3: 'Draw Trumps, then start cross ruffing',
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF02']
  },
  {
    qid: 188,
    qowner: 'Richard',
    qkey: 'WBF03',
    qdetail:
      'https://www.youtube.com/watch?v=_6U0h2afJHE&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=72',
    qcorrect: 'Play on diamonds',
    qbad1: 'Play on clubs',
    qbad2: 'Play on hearts',
    qbad3: 'Play on spades',
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF03']
  },
  {
    qid: 189,
    qowner: 'Richard',
    qkey: 'WBF04',
    qdetail:
      'https://www.youtube.com/watch?v=8ruVr0EoL2A&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=70',
    qcorrect: 'Lead Diamonds',
    qbad1: 'Lead Clubs',
    qbad2: 'Lead Hearts',
    qbad3: 'Lead Spades',
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF04']
  },
  {
    qid: 190,
    qowner: 'Richard',
    qkey: 'WBF05',
    qdetail:
      'https://www.youtube.com/watch?v=pdWfV9Hae1c&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=69',
    qcorrect: 'Win in hand, play on Clubs',
    qbad1: 'Win in hand, play on Diamonds',
    qbad2: 'Win in hand, play on Spades',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF05']
  },
  {
    qid: 191,
    qowner: 'Richard',
    qkey: 'WBF06',
    qdetail:
      'https://www.youtube.com/watch?v=qhV62zvJV3M&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=66',
    qcorrect: '1S',
    qbad1: '1C',
    qbad2: '2S showing 5/4',
    qbad3: 'Multi 2D',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF06']
  },
  {
    qid: 192,
    qowner: 'Richard',
    qkey: 'WBF07',
    qdetail:
      'https://www.youtube.com/watch?v=rZKQJnbvRmg&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=64',
    qcorrect: 'Pass',
    qbad1: '2D',
    qbad2: '1NT',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF07']
  },
  {
    qid: 193,
    qowner: 'Richard',
    qkey: 'WBF08',
    qdetail:
      'https://www.youtube.com/watch?v=8DCJYS8aiQM&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=60',
    qcorrect: 'Lead a Heart',
    qbad1: 'Lead a Spade',
    qbad2: 'Lead a Diamond',
    qbad3: 'Lead a Club',
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF08']
  },
  {
    qid: 194,
    qowner: 'Richard',
    qkey: 'WBF09',
    qdetail:
      'https://www.youtube.com/watch?v=eypluyv2jLY&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=59',
    qcorrect: 'Lead a Heart',
    qbad1: 'Lead a Spade',
    qbad2: 'Lead a Diamond',
    qbad3: 'Lead a Club',
    qgroup1: 'WBF',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['WBF09']
  },
  {
    qid: 195,
    qowner: 'Richard',
    qkey: 'WBF10',
    qdetail:
      'https://www.youtube.com/watch?v=LNh-xtt2KRw&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=62',
    qcorrect: '2S',
    qbad1: 'Double',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF10']
  },
  {
    qid: 196,
    qowner: 'Richard',
    qkey: 'WBF11',
    qdetail:
      'https://www.youtube.com/watch?v=SW_6JrllmKc&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=53',
    qcorrect: '2C Stayman',
    qbad1: 'Pass',
    qbad2: 'Systematic transfer to Diamonds',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF11']
  },
  {
    qid: 197,
    qowner: 'Richard',
    qkey: 'WBF12',
    qdetail:
      'https://www.youtube.com/watch?v=26wCX47i6u8&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=51',
    qcorrect: '2/1 2C Game force',
    qbad1: '2/1 2D Game force',
    qbad2: '3NT',
    qbad3: '4H',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF12']
  },
  {
    qid: 198,
    qowner: 'Richard',
    qkey: 'WBF13',
    qdetail:
      'https://www.youtube.com/watch?v=NgFRjCCjCMo&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=50',
    qcorrect: 'Double, Penalty',
    qbad1: '3NT',
    qbad2: 'Double, Take Out',
    qbad3: '2NT Lebensohl',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF13']
  },
  {
    qid: 199,
    qowner: 'Richard',
    qkey: 'WBF14',
    qdetail:
      'https://www.youtube.com/watch?v=7saKaHoh1Fc&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=48',
    qcorrect: 'Pass',
    qbad1: '2NT',
    qbad2: '3D',
    qbad3: '3H',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF14']
  },
  {
    qid: 200,
    qowner: 'Richard',
    qkey: 'WBF15',
    qdetail:
      'https://www.youtube.com/watch?v=WCGBZNWoY7o&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=44',
    qcorrect: '4H',
    qbad1: '3H',
    qbad2: '2H',
    qbad3: '4D',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF15']
  },
  {
    qid: 201,
    qowner: 'Richard',
    qkey: 'WBF16',
    qdetail:
      'https://www.youtube.com/watch?v=gs161tAhc4A&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=41',
    qcorrect: 'Redouble',
    qbad1: '1S',
    qbad2: '1NT',
    qbad3: '2H',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF16']
  },
  {
    qid: 202,
    qowner: 'Richard',
    qkey: 'WBF17',
    qdetail:
      'https://www.youtube.com/watch?v=TVlYY8rzLM0&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=40',
    qcorrect: '2/1 2D Game Force',
    qbad1: '1S',
    qbad2: null,
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF17']
  },
  {
    qid: 203,
    qowner: 'Richard',
    qkey: 'WBF18',
    qdetail:
      'https://www.youtube.com/watch?v=PnpUJxh5YY8&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=38',
    qcorrect: '4C Splinter ',
    qbad1: '3S Invitational',
    qbad2: '4S',
    qbad3: '3D forcing',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF18']
  },
  {
    qid: 204,
    qowner: 'Richard',
    qkey: 'WBF19',
    qdetail:
      'https://www.youtube.com/watch?v=thq3P6caT7o&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=36',
    qcorrect: '3H',
    qbad1: '3NT',
    qbad2: '4H',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF19']
  },
  {
    qid: 205,
    qowner: 'Richard',
    qkey: 'WBF20',
    qdetail:
      'https://www.youtube.com/watch?v=Qo6LIWMTGeo&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=34',
    qcorrect: '2H',
    qbad1: 'Double',
    qbad2: '2D',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF20']
  },
  {
    qid: 206,
    qowner: 'Richard',
    qkey: 'WBF21',
    qdetail:
      'https://www.youtube.com/watch?v=StJtgZm_kSM&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=32',
    qcorrect: 'Pass',
    qbad1: '1NT',
    qbad2: '2S preemptive',
    qbad3: 'Redouble',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF21']
  },
  {
    qid: 207,
    qowner: 'Richard',
    qkey: 'WBF22',
    qdetail:
      'https://www.youtube.com/watch?v=heFisuDLo44&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=30',
    qcorrect: '4S',
    qbad1: 'Double',
    qbad2: '4NT',
    qbad3: 'Pass',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF22']
  },
  {
    qid: 208,
    qowner: 'Richard',
    qkey: 'WBF23',
    qdetail:
      'https://www.youtube.com/watch?v=KAmzSaqvvWE&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=28',
    qcorrect: '5C',
    qbad1: '4H',
    qbad2: '4NT',
    qbad3: '4C',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF23']
  },
  {
    qid: 209,
    qowner: 'Richard',
    qkey: 'WBF24',
    qdetail:
      'https://www.youtube.com/watch?v=MbfwoU_6WQU&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=27',
    qcorrect: '3H',
    qbad1: '3D',
    qbad2: '4S',
    qbad3: 'Double',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF24']
  },
  {
    qid: 210,
    qowner: 'Richard',
    qkey: 'WBF25',
    qdetail:
      'https://www.youtube.com/watch?v=4F3Hs-64CZM&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=25',
    qcorrect: '1S',
    qbad1: '2S showing 5/4',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF25']
  },
  {
    qid: 211,
    qowner: 'Richard',
    qkey: 'WBF26',
    qdetail:
      'https://www.youtube.com/watch?v=Nx0UTV1ymQU&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=23',
    qcorrect: 'Double',
    qbad1: '2S',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF26']
  },
  {
    qid: 212,
    qowner: 'Richard',
    qkey: 'WBF27',
    qdetail:
      'https://www.youtube.com/watch?v=haWwQvOxbA0&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=20',
    qcorrect: '3D',
    qbad1: '2D',
    qbad2: 'pass',
    qbad3: '4D',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF27']
  },
  {
    qid: 213,
    qowner: 'Richard',
    qkey: 'WBF28',
    qdetail:
      'https://www.youtube.com/watch?v=DDA2u5B_jNg&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=14',
    qcorrect: 'Pass',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF28']
  },
  {
    qid: 214,
    qowner: 'Richard',
    qkey: 'WBF29',
    qdetail:
      'https://www.youtube.com/watch?v=Pm-6EiBFaSo&list=PLpTZMBT2rnfEfJSu9rop3cxuTbIKL5wVj&index=18',
    qcorrect: '1S',
    qbad1: 'Pass',
    qbad2: null,
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF29']
  },
  {
    qid: 215,
    qowner: 'Richard',
    qkey: 'WBF30',
    qdetail: 'https://www.youtube.com/watch?v=71mwnR0BC18',
    qcorrect: '1NT 15-17',
    qbad1: '1D',
    qbad2: null,
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF30']
  },
  {
    qid: 216,
    qowner: 'Richard',
    qkey: 'WBF31',
    qdetail: 'https://www.youtube.com/watch?v=AFj_ArhyNWw',
    qcorrect: '2C',
    qbad1: 'Pass',
    qbad2: 'Redouble',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF31']
  },
  {
    qid: 217,
    qowner: 'Richard',
    qkey: 'WBF32',
    qdetail: 'https://www.youtube.com/watch?v=S1dC5I_zO50',
    qcorrect: '2S',
    qbad1: 'Pass',
    qbad2: '3C',
    qbad3: 'Double',
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF32']
  },
  {
    qid: 218,
    qowner: 'Richard',
    qkey: 'WBF33',
    qdetail: 'https://www.youtube.com/watch?v=m6-erhM0XeA',
    qcorrect: '3H',
    qbad1: '2H',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF33']
  },
  {
    qid: 219,
    qowner: 'Richard',
    qkey: 'WBF34',
    qdetail: 'https://www.youtube.com/watch?v=HtlNh_3qxt0',
    qcorrect: '2D',
    qbad1: '3S',
    qbad2: '4S',
    qbad3: null,
    qgroup1: 'WBF',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['WBF34']
  },
  {
    qid: 220,
    qowner: 'public',
    qkey: '2WayCheckBack01',
    qdetail: 'What is your bid ?',
    qcorrect: '2D two way checkback',
    qbad1: '2C two way checkback',
    qbad2: '2H showing 5S and 4+H',
    qbad3: '2NT invitational',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 221,
    qowner: 'public',
    qkey: '2WayCheckBack02',
    qdetail: 'What does their 2D bid mean ?',
    qcorrect: 'Game forcing checkback',
    qbad1: 'Signoff in Diamonds',
    qbad2: 'Transfer to Hearts',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 222,
    qowner: 'public',
    qkey: '2WayCheckBack03',
    qdetail: 'What do you bid ?',
    qcorrect: '2H showing 4 hearts',
    qbad1: 'Pass ',
    qbad2: '2H accepting transfer',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 223,
    qowner: 'public',
    qkey: '2WayCheckBack04',
    qdetail: 'What is partners bid of 3D ?',
    qcorrect: 'Invitational in Diamonds',
    qbad1: 'transfer to hearts',
    qbad2: 'sign off in diamonds',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 224,
    qowner: 'public',
    qkey: '2WayCheckBack05',
    qdetail: 'What do you bid ?',
    qcorrect: '2S showing 5 spades',
    qbad1: '2NT',
    qbad2: '3C showing 4+ clubs',
    qbad3: '3NT',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 225,
    qowner: 'public',
    qkey: '2WayCheckBack06',
    qdetail: 'What do you bid ?',
    qcorrect: '4S',
    qbad1: '2D checkback game force',
    qbad2: '2C checkback invitational',
    qbad3: '3S invitational',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 226,
    qowner: 'public',
    qkey: '2WayCheckBack07',
    qdetail: 'What does your partners bid mean ?',
    qcorrect: '5S & 4+ diamonds',
    qbad1: '2 way game force checkback',
    qbad2: null,
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 227,
    qowner: 'public',
    qkey: '2WayCheckBack08',
    qdetail: 'What do we bid ?',
    qcorrect: '2S showing 3 spades',
    qbad1: '2H showing 5 hearts',
    qbad2: '3S game invite',
    qbad3: '4S accept invite',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 228,
    qowner: 'public',
    qkey: '2WayCheckBack09',
    qdetail: 'What do you bid ?',
    qcorrect: '2D game force checkback',
    qbad1: '2H showing 4+ hearts',
    qbad2: '4H asking partner to choose Hearts or Spades',
    qbad3: '3H game force showing 5 Spades and 4 Hearts',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 229,
    qowner: 'public',
    qkey: '2WayCheckBack10',
    qdetail: 'How do you invite in hearts ?',
    qcorrect: '2C invitational checkback',
    qbad1: '2D checkback',
    qbad2: '3H invitational',
    qbad3: '2H Invitational',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 230,
    qowner: 'public',
    qkey: '2WayCheckBack11',
    qdetail: 'What is your bid with 4 clubs ?',
    qcorrect: '2D relay',
    qbad1: 'Pass, partner has your clubs',
    qbad2: '3C partner has 5 clubs',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 231,
    qowner: 'public',
    qkey: '2WayCheckBack12',
    qdetail: 'How do you invite in hearts ?',
    qcorrect: '2H invitational',
    qbad1: '3H invitational',
    qbad2: '2NT Invitational',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 232,
    qowner: 'public',
    qkey: '2WayCheckBack13',
    qdetail: 'What is your bid ?',
    qcorrect: '2D relay',
    qbad1: 'Pass, agree clubs',
    qbad2: '2H show hearts',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 233,
    qowner: 'public',
    qkey: '2WayCheckBack14',
    qdetail: 'What does 2S mean ?',
    qcorrect: 'Invitational with 5+ Spades',
    qbad1: 'Sign-off in 2S',
    qbad2: '4 Spades and 4 Hearts',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 234,
    qowner: 'public',
    qkey: '2WayCheckBack15',
    qdetail: 'How do you invite in hearts ?',
    qcorrect: '2C invitational checkback',
    qbad1: '2H show 5 hearts',
    qbad2: '3H Invitational',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 235,
    qowner: 'public',
    qkey: '2WayCheckBack16',
    qdetail: "What is partner's hand ?",
    qcorrect: '5 Spades and 4 Hearts invitational',
    qbad1: '5 Spades and 5 Hearts invitational',
    qbad2: '5 Spades and 4 Hearts, 2 level stop',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 236,
    qowner: 'public',
    qkey: '2WayCheckBack17',
    qdetail: 'What is your bid ?',
    qcorrect: '4H with a double fit Spades/Hearts',
    qbad1: '4S with a double fir Spades and Hearts',
    qbad2: '3H invitational',
    qbad3: '3S Invitational',
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 237,
    qowner: 'public',
    qkey: '2WayCheckBack18',
    qdetail: 'What is your bid to stop in 2H',
    qcorrect: '2H',
    qbad1: '2C and partner will bid 2D and we will bid 2H',
    qbad2: '2D transfer to Hearts',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 238,
    qowner: 'public',
    qkey: '2WayCheckBack19',
    qdetail: 'How do you stop in 2D ?',
    qcorrect: '2C transfer to 2D',
    qbad1: '2D partner will pass',
    qbad2: null,
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 239,
    qowner: 'public',
    qkey: '2WayCheckBack20',
    qdetail: 'You hold 3 spades and 14HCP and open.What is next your bid ?',
    qcorrect: 'Pass',
    qbad1: '3S Invitational',
    qbad2: null,
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 240,
    qowner: 'public',
    qkey: '2WayCheckBack21',
    qdetail: 'What is your bid ?',
    qcorrect: '2C transfer to 2D',
    qbad1: '2D signoff',
    qbad2: 'pass',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 241,
    qowner: 'public',
    qkey: '2WayCheckBack22',
    qdetail: "What is partner's hand ?",
    qcorrect: '5 Spades and 4 Hearts weak',
    qbad1: '5 Spades and 4 Hearts invitational',
    qbad2: '5/5 Spades and hearts invitational',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 242,
    qowner: 'public',
    qkey: '2WayCheckBack23',
    qdetail: 'What is your bid ?',
    qcorrect: '2C relay to diamonds',
    qbad1: '2D signoff',
    qbad2: '2NT Invitational',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 243,
    qowner: 'public',
    qkey: '2WayCheckBack24',
    qdetail:
      'You have 15HCP with 5 card diamonds and 4 Spades.  What bid do you make ?',
    qcorrect: '2S responders reverse, forcing',
    qbad1: '2D checkback, game force',
    qbad2: '3S game force',
    qbad3: null,
    qgroup1: 'TwoWayCheckback',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['2WayCheckBack']
  },
  {
    qid: 244,
    qowner: 'public',
    qkey: 'BergenRaises01',
    qdetail:
      "What do you respond to partner's 1H with 3 card support and 6-9 hcp ?",
    qcorrect: '2H',
    qbad1: '3H',
    qbad2: '3C',
    qbad3: '3D',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 245,
    qowner: 'public',
    qkey: 'BergenRaises02',
    qdetail:
      "What do you respond to partner's 1H with 3 card support and 10-12 hcp ?",
    qcorrect: '2S',
    qbad1: '3C',
    qbad2: '3D',
    qbad3: '3H',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 246,
    qowner: 'public',
    qkey: 'BergenRaises03',
    qdetail:
      "What do you respond to partner's 1S with 3 card support and 10-12 hcp ?",
    qcorrect: '3H',
    qbad1: '3C',
    qbad2: '3D',
    qbad3: '3S',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 247,
    qowner: 'public',
    qkey: 'BergenRaises04',
    qdetail:
      "What do you respond to partner's 1H with 3 card support and 16+ hcp ?",
    qcorrect: '2x delayed game raise',
    qbad1: '2NT jacoby',
    qbad2: '3NT pudding raise',
    qbad3: '4H',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 248,
    qowner: 'public',
    qkey: 'BergenRaises05',
    qdetail:
      "What do you respond to partner's 1H with 4 card support and 6-9 hcp ?",
    qcorrect: '3C',
    qbad1: '3H',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 249,
    qowner: 'public',
    qkey: 'BergenRaises06',
    qdetail:
      "What do you respond to partner's 1H with 4 card support and 10-12 hcp ?",
    qcorrect: '3D',
    qbad1: '3C',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 250,
    qowner: 'public',
    qkey: 'BergenRaises07',
    qdetail:
      "What do you respond to partner's 1H with 4 card support and 0-5 hcp ?",
    qcorrect: '3H',
    qbad1: '3C',
    qbad2: '2H',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 251,
    qowner: 'public',
    qkey: 'BergenRaises08',
    qdetail:
      "What do you respond to partner's 1H with 4 card support and 13+ hcp ?",
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '4H',
    qbad3: '3NT',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 252,
    qowner: 'public',
    qkey: 'BergenRaises09',
    qdetail:
      "What do you respond to partner's 1H with 4 card support and 16+ hcp ?",
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '4H',
    qbad3: '3NT',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 253,
    qowner: 'public',
    qkey: 'BergenRaises10',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 0-5 hcp, VUL and NO singleton ?",
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '3D',
    qbad3: '3C',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 254,
    qowner: 'public',
    qkey: 'BergenRaises11',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 0-5 hcp, VUL and a SINGLETON ?",
    qcorrect: '4H',
    qbad1: '3H',
    qbad2: '3D',
    qbad3: '3C',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 255,
    qowner: 'public',
    qkey: 'BergenRaises12',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 0-5 hcp, NON-VUL and NO singleton ?",
    qcorrect: '4H',
    qbad1: '3H',
    qbad2: '3D',
    qbad3: '3C',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 256,
    qowner: 'public',
    qkey: 'BergenRaises13',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 0-5 hcp, NON-VUL and a SINGLETON ?",
    qcorrect: '4H',
    qbad1: '3H',
    qbad2: '3D',
    qbad3: '3C',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 257,
    qowner: 'public',
    qkey: 'BergenRaises14',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 6-9 hcp ?",
    qcorrect: '4H',
    qbad1: '3H',
    qbad2: '3D',
    qbad3: '3C',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 258,
    qowner: 'public',
    qkey: 'BergenRaises15',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 10-12 hcp ?",
    qcorrect: '3D',
    qbad1: '3C',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 259,
    qowner: 'public',
    qkey: 'BergenRaises16',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 13+ hcp ?",
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '4H',
    qbad3: '3NT',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 260,
    qowner: 'public',
    qkey: 'BergenRaises17',
    qdetail:
      "What do you respond to partner's 1H with 5 card support and 16+ hcp ?",
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '4H',
    qbad3: '3NT',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 261,
    qowner: 'public',
    qkey: 'BergenRaises18',
    qdetail: 'What is your bid ?',
    qcorrect: '3D',
    qbad1: '3C',
    qbad2: '3S',
    qbad3: '2S',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 262,
    qowner: 'public',
    qkey: 'BergenRaises19',
    qdetail: 'What is your bid ?',
    qcorrect: '2NT Jacoby',
    qbad1: '3D',
    qbad2: '3S',
    qbad3: '4S',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 263,
    qowner: 'public',
    qkey: 'BergenRaises20',
    qdetail: 'What is your bid ?',
    qcorrect: '2NT Jacoby',
    qbad1: '3D',
    qbad2: '3S',
    qbad3: '4S',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 264,
    qowner: 'public',
    qkey: 'BergenRaises21',
    qdetail: 'What is your bid ?',
    qcorrect: '2D game force',
    qbad1: '3NT pudding raise',
    qbad2: '2NT Jocoby',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 265,
    qowner: 'public',
    qkey: 'BergenRaises22',
    qdetail: 'What is your bid ?',
    qcorrect: '2D delayed game raise or 3NT pudding raise',
    qbad1: '2NT jacoby',
    qbad2: null,
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 266,
    qowner: 'public',
    qkey: 'BergenRaises23',
    qdetail: 'What is your bid and you are PLAYING 2/1 ?',
    qcorrect: '2C game force',
    qbad1: '3NT pudding raise',
    qbad2: '2NT Jocoby',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 267,
    qowner: 'public',
    qkey: 'BergenRaises24',
    qdetail: 'What is your bid and you are PLAYING STANDARD AMERICAN ?',
    qcorrect: '3NT pudding raise',
    qbad1: '2NT jacoby',
    qbad2: '2C game force',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 268,
    qowner: 'public',
    qkey: 'BergenRaises25',
    qdetail: 'What does 3D by partner mean ?',
    qcorrect: 'Game try, accept if maximum',
    qbad1: 'Min, forced to bid 3S',
    qbad2: 'Game force',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 269,
    qowner: 'public',
    qkey: 'BergenRaises26',
    qdetail: 'What does 3H by partner mean ?',
    qcorrect: 'Game try, accept if not minimum',
    qbad1: 'Min, forced to bid 3S',
    qbad2: 'Game force',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 270,
    qowner: 'public',
    qkey: 'BergenRaises27',
    qdetail: 'What does 3S by partner mean ?',
    qcorrect: 'Sign off',
    qbad1: 'Game try',
    qbad2: 'Game force',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 271,
    qowner: 'public',
    qkey: 'BergenRaises28',
    qdetail: 'What does 4C by partner mean ?',
    qcorrect: 'Club Control',
    qbad1: 'Fit in clubs',
    qbad2: 'Partner forgot the system',
    qbad3: 'Gerber',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 272,
    qowner: 'public',
    qkey: 'BergenRaises29',
    qdetail: 'What does 4C by partner mean ?',
    qcorrect: 'Club Control',
    qbad1: 'Partner is 5/5 in spades and clubs',
    qbad2: 'Partner forgot the system',
    qbad3: 'Gerber',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 273,
    qowner: 'public',
    qkey: 'BergenRaises30',
    qdetail: 'What does 3C by partner mean ?',
    qcorrect: 'Shortage in Clubs',
    qbad1: 'Club suit 4+',
    qbad2: 'Waiting bid',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 274,
    qowner: 'public',
    qkey: 'BergenRaises31',
    qdetail: 'What does 3NT by partner mean ?',
    qcorrect: '15/16-17 no shortage',
    qbad1: 'To play',
    qbad2: '15/16-17 may have a shortage',
    qbad3: 'Relay to 4S',
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 275,
    qowner: 'public',
    qkey: 'BergenRaises32',
    qdetail: 'What does 3S by partner mean ?',
    qcorrect: '18-19 no shortage',
    qbad1: 'To play, partner is minimum',
    qbad2: '18-19 may have a shortage',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 276,
    qowner: 'public',
    qkey: 'BergenRaises33',
    qdetail: 'What does 4S by partner mean ?',
    qcorrect: '11-14/15 no shortage',
    qbad1: '11-14/15 may have a shortage',
    qbad2: 'Minimum, to play',
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 277,
    qowner: 'public',
    qkey: 'BergenRaises34',
    qdetail: 'You are PLAYING 2/1.  How do you agree spades ?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: null,
    qbad3: null,
    qgroup1: 'BergenRaises',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['BergenRaises']
  },
  {
    qid: 278,
    qowner: 'public',
    qkey: 'Quantitative4NT01',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Ace Ask',
    qbad2: 'Pre-emptive',
    qbad3: '7NT ask',
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 279,
    qowner: 'public',
    qkey: 'Quantitative4NT02',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Ace Ask',
    qbad2: 'Pre-emptive',
    qbad3: '7NT ask',
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 280,
    qowner: 'public',
    qkey: 'Quantitative4NT03',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Roman Key Card, agreeing Spades',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 281,
    qowner: 'public',
    qkey: 'Quantitative4NT04',
    qdetail: 'What is 3H ?',
    qcorrect: 'Agreeing Spades, looking at Slam',
    qbad1: 'Self agreeing hearts as trumps',
    qbad2: 'Looking for NT, asking for a heart stopper',
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 282,
    qowner: 'public',
    qkey: 'Quantitative4NT05',
    qdetail: 'What is 3S ?',
    qcorrect: 'Agreeing Hearts looking at Slam',
    qbad1: 'Self agreeing Spades as trumps',
    qbad2: 'Looking for NT, asking for a Spade stopper',
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 283,
    qowner: 'public',
    qkey: 'Quantitative4NT06',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Roman Key Card, agreeing Hearts',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 284,
    qowner: 'public',
    qkey: 'Quantitative4NT07',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Roman Key Card, agreeing Hearts',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 285,
    qowner: 'public',
    qkey: 'Quantitative4NT08',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Quantitative 4NT',
    qbad1: 'Roman Key Card, agreeing Hearts',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 286,
    qowner: 'public',
    qkey: 'Quantitative4NT09',
    qdetail: 'What is 2S ?',
    qcorrect: 'Agreeing Hearts',
    qbad1: 'Asking for stop in Spades',
    qbad2: 'Psyche',
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 287,
    qowner: 'public',
    qkey: 'Quantitative4NT10',
    qdetail: 'What is 4NT ?',
    qcorrect: 'Roman Key Card, agreeing Hearts',
    qbad1: 'Quantitative 4NT',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Quantitative4NT',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Quantative4NT']
  },
  {
    qid: 288,
    qowner: 'public',
    qkey: 'Cue1st2ndControls01',
    qdetail: 'What is 3S ?',
    qcorrect: 'Control in Spades',
    qbad1: 'Suit Trial bid',
    qbad2: 'Natural spades',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 289,
    qowner: 'public',
    qkey: 'Cue1st2ndControls02',
    qdetail: 'What is 2S ?',
    qcorrect: 'Game try trial bid',
    qbad1: 'Control in Spades',
    qbad2: 'Natural spades',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 290,
    qowner: 'public',
    qkey: 'Cue1st2ndControls03',
    qdetail: 'What is 3S ?',
    qcorrect: 'Agreeing hearts as trumps',
    qbad1: 'Asking for a stop in Spades',
    qbad2: 'Showing 5 Spades',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 291,
    qowner: 'public',
    qkey: 'Cue1st2ndControls04',
    qdetail: '3NT (3 hearts, 13-15 hcp).  What is 4C ?',
    qcorrect: 'Cue of Clubs, agreeing Hearts',
    qbad1: 'Gerber',
    qbad2: '5+ clubs',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 292,
    qowner: 'public',
    qkey: 'Cue1st2ndControls05',
    qdetail: 'What is 3S ?',
    qcorrect: 'Agreeing spades, start of Cue bidding',
    qbad1: 'Invitational in Spades',
    qbad2: 'Weak Spades',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 293,
    qowner: 'public',
    qkey: 'Cue1st2ndControls06',
    qdetail: 'First round control is ?',
    qcorrect: 'Ace or Void',
    qbad1: 'Ace or King',
    qbad2: 'Ace',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 294,
    qowner: 'public',
    qkey: 'Cue1st2ndControls07',
    qdetail: 'Second round control is ?',
    qcorrect: 'King or Singleton',
    qbad1: 'King',
    qbad2: 'Singleton',
    qbad3: 'Ace and King',
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 295,
    qowner: 'public',
    qkey: 'Cue1st2ndControls08',
    qdetail: 'What is 3S ?',
    qcorrect: 'Cue Raise agreeing Hearts, Control in Spades',
    qbad1: 'Asking for a stop in Spades',
    qbad2: 'Cue Raise agreeing Hearts',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 296,
    qowner: 'public',
    qkey: 'Cue1st2ndControls09',
    qdetail: 'You have Ace of diamonds and King of Clubs, what do you bid ? ',
    qcorrect: '4C Control in clubs',
    qbad1: '4D showing a control in diamonds',
    qbad2: '4D showing Ace of diamonds',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 297,
    qowner: 'public',
    qkey: 'Cue1st2ndControls10',
    qdetail: 'What does 4C mean ?',
    qcorrect: '1st or 2nd round control in Clubs',
    qbad1: 'Gerber',
    qbad2: 'Waiting bid',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 298,
    qowner: 'public',
    qkey: 'Cue1st2ndControls11',
    qdetail: 'What does 4D mean ?',
    qcorrect: '1st or 2nd round control in Diamonds, NO control in Clubs',
    qbad1: '1st or 2nd round control in Diamonds',
    qbad2: 'Ace of Diamonds',
    qbad3: 'Natural diamond suit',
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 299,
    qowner: 'public',
    qkey: 'Cue1st2ndControls12',
    qdetail: 'What does 4H mean ?',
    qcorrect: 'Sign off, not interested in Slam',
    qbad1: 'Waiting bid',
    qbad2: 'Asking partner to bid Roman Keycard',
    qbad3: 'Pass/Correct Hearts or Spades',
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 300,
    qowner: 'public',
    qkey: 'Cue1st2ndControls13',
    qdetail: '3D (bergen).  What does 4C mean ?',
    qcorrect: '1st or 2nd round control in Clubs, NO control in Spades',
    qbad1: 'Splinter in Clubs',
    qbad2: '1st or 2nd round control in Clubs',
    qbad3: 'Gerber',
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 301,
    qowner: 'public',
    qkey: 'Cue1st2ndControls14',
    qdetail: 'What is 4C ?',
    qcorrect: 'Agreeing hearts.  Control in Clubs, NO control in Spades',
    qbad1: 'Agreeing hearts.  Control in Clubs.',
    qbad2: 'Gerber',
    qbad3: 'Splinter in Clubs',
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 302,
    qowner: 'public',
    qkey: 'Cue1st2ndControls15',
    qdetail: '3NT(3card heart and 12-15 hcp).  What is your bid ?',
    qcorrect: '4C Control in clubs.',
    qbad1: '4C Control in clubs AND Spades',
    qbad2: '4NT RKC',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 303,
    qowner: 'public',
    qkey: 'Cue1st2ndControls16',
    qdetail: '3C(stayman).  What is 3S ?',
    qcorrect: 'Interest in a Heart Slam, start of Cue Bidding',
    qbad1: '5+ Spades',
    qbad2: 'Ask for a Spade stop',
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 304,
    qowner: 'public',
    qkey: 'Cue1st2ndControls17',
    qdetail: 'What does 4D show ?',
    qcorrect: 'Control in Diamonds but NOT in clubs',
    qbad1: 'Controls in Diamonds AND Clubs',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Cue1st2ndControls',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['Cue1st2ndControls']
  },
  {
    qid: 305,
    qowner: 'public',
    qkey: 'MichaelsCueBid01',
    qdetail: 'What does this cue bid mean ?',
    qcorrect: '5/5 Spades and a Minor',
    qbad1: 'Has Hearts',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 306,
    qowner: 'public',
    qkey: 'MichaelsCueBid02',
    qdetail: 'What does this cue bid mean ?',
    qcorrect: '5/5 Clubs and Diamonds',
    qbad1: '18+ stops in hearts',
    qbad2: '5/5 Spades and a minor',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 307,
    qowner: 'public',
    qkey: 'MichaelsCueBid03',
    qdetail: 'Is this Michaels ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 308,
    qowner: 'public',
    qkey: 'MichaelsCueBid04',
    qdetail: '2D multi.  Is this Michaels ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 309,
    qowner: 'public',
    qkey: 'MichaelsCueBid05',
    qdetail: 'Strong artificial club.  Is this Michaels ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 310,
    qowner: 'public',
    qkey: 'MichaelsCueBid06',
    qdetail: '1C shows 2+.  Is this Michaels ?',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 311,
    qowner: 'public',
    qkey: 'MichaelsCueBid07',
    qdetail: 'Is this Michaels ?',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 312,
    qowner: 'public',
    qkey: 'MichaelsCueBid08',
    qdetail: 'Where opponents have the points Michaels is a good disruptor ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 313,
    qowner: 'public',
    qkey: 'MichaelsCueBid09',
    qdetail:
      'Michaels is good at all vulnerabilities as a disruptor of opponents ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 314,
    qowner: 'public',
    qkey: 'MichaelsCueBid10',
    qdetail: 'Vulnerability counts on whether to bid Michaels',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 315,
    qowner: 'public',
    qkey: 'MichaelsCueBid11',
    qdetail: 'What hand features influence whether to bid Michaels',
    qcorrect:
      'Vulnerability, Minimum level of partner response, Point count, Partnership agreement',
    qbad1: 'Vulnerability',
    qbad2: 'Point Count',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 316,
    qowner: 'public',
    qkey: 'MichaelsCueBid12',
    qdetail: 'Favourable vulnerability we can be very weak ?',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 317,
    qowner: 'public',
    qkey: 'MichaelsCueBid13',
    qdetail: 'What does 3C show ?',
    qcorrect: 'Pass or correct',
    qbad1: 'Long clubs to play',
    qbad2: 'Mini Gerber',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 318,
    qowner: 'public',
    qkey: 'MichaelsCueBid14',
    qdetail: 'What does 2NT mean ?',
    qcorrect: 'Asking for the Michaels Minor',
    qbad1: 'To play',
    qbad2: 'Invite to 3NT',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 319,
    qowner: 'public',
    qkey: 'MichaelsCueBid15',
    qdetail: 'What does this mean ?',
    qcorrect: 'Partnership agreement',
    qbad1: 'Diamonds',
    qbad2: 'Clubs',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 320,
    qowner: 'public',
    qkey: 'MichaelsCueBid16',
    qdetail: 'What does this show ?',
    qcorrect: 'Hearts and Clubs 5/5',
    qbad1: 'Majors',
    qbad2: '18+ stops in diamonds',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 321,
    qowner: 'public',
    qkey: 'MichaelsCueBid17',
    qdetail: 'What is your bid ?',
    qcorrect: 'Pass',
    qbad1: '2NT',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 322,
    qowner: 'public',
    qkey: 'MichaelsCueBid18',
    qdetail: 'What does 2NT mean ?',
    qcorrect: 'Asks for partners minor',
    qbad1: 'To play',
    qbad2: 'Looking for 3NT',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 323,
    qowner: 'public',
    qkey: 'MichaelsCueBid19',
    qdetail: 'What does 3NT mean ?',
    qcorrect: 'To play',
    qbad1: 'Ask for partners minor',
    qbad2: null,
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 324,
    qowner: 'public',
    qkey: 'MichaelsCueBid20',
    qdetail: 'What does 4C mean ?',
    qcorrect: 'Pass or correct',
    qbad1: 'Gerber',
    qbad2: 'Confirm Clubs',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 325,
    qowner: 'public',
    qkey: 'MichaelsCueBid21',
    qdetail: 'What does 4NT mean ?',
    qcorrect: 'Bid 5 of your minor',
    qbad1: 'Blackwood in Spades',
    qbad2: 'Quantitive 4NT',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 326,
    qowner: 'public',
    qkey: 'MichaelsCueBid22',
    qdetail: 'What does 3S mean ?',
    qcorrect: 'Pre-emptive in spades',
    qbad1: 'Invitational in Spades',
    qbad2: 'Bid your minor',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 327,
    qowner: 'public',
    qkey: 'MichaelsCueBid23',
    qdetail: 'What is your bid ?',
    qcorrect: '4H',
    qbad1: '3NT',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 328,
    qowner: 'public',
    qkey: 'MichaelsCueBid24',
    qdetail: 'What do you bid with a minimum ?',
    qcorrect: '3H',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 329,
    qowner: 'public',
    qkey: 'MichaelsCueBid25',
    qdetail: 'What do you bid with a maximum ?',
    qcorrect: '3S',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'MichaelsCueBid',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['MichaelsCueBidPeteHollands']
  },
  {
    qid: 330,
    qowner: 'public',
    qkey: 'Play01',
    qdetail:
      'Dummy (North) leads the Queen from dummy, do you cover with your King ?',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 331,
    qowner: 'public',
    qkey: 'Play02',
    qdetail:
      'Dummy (North) leads the Jack from dummy, do you cover with your King ?',
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 332,
    qowner: 'public',
    qkey: 'Play03',
    qdetail:
      'Dummy (North) leads the Queen from dummy, do you cover with your King ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 333,
    qowner: 'public',
    qkey: 'Play04',
    qdetail: 'Do you cover the Queen from dummy with your King ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 334,
    qowner: 'public',
    qkey: 'Play05',
    qdetail:
      "If you didn't cover the Queen with your King, do you subsequently cover the Jack from dummy (North) ?",
    qcorrect: 'Yes',
    qbad1: 'No',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 335,
    qowner: 'public',
    qkey: 'Play06',
    qdetail:
      'Defending as West, after you lead JS and declarer wins in hand with AS, delarer leads JH, do you cover with KH ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Play',
    qgroup2: 'Play',
    qgroup3: 'None',
    qrefs: ['PlayEBU']
  },
  {
    qid: 336,
    qowner: 'public',
    qkey: 'Lebensohl01',
    qdetail:
      'What do you bid without interference to your partners 1NT opening ?',
    qcorrect: 'Transfer to diamonds using your agreed convention',
    qbad1: '2NT Lebensohl',
    qbad2: '3D',
    qbad3: 'Pass',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 337,
    qowner: 'public',
    qkey: 'Lebensohl02',
    qdetail:
      'What do you bid with 2H interference to your partners 1NT opening ?',
    qcorrect: '2NT',
    qbad1: 'Pass',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 338,
    qowner: 'public',
    qkey: 'Lebensohl03',
    qdetail:
      'What do you bid without interference to your partners 1NT opening ?',
    qcorrect: '3D',
    qbad1: 'Transfer to diamonds',
    qbad2: '3NT',
    qbad3: '2NT',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 339,
    qowner: 'public',
    qkey: 'Lebensohl04',
    qdetail:
      'What do you bid with 2H interference to your partners 1NT opening ?',
    qcorrect: '3D',
    qbad1: 'Transfer to diamonds',
    qbad2: '3NT',
    qbad3: '2NT',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 340,
    qowner: 'public',
    qkey: 'Lebensohl05',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3C',
    qbad1: 'Pass',
    qbad2: '3NT',
    qbad3: '3S',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 341,
    qowner: 'public',
    qkey: 'Lebensohl06',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3D',
    qbad1: '3NT',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger01']
  },
  {
    qid: 342,
    qowner: 'public',
    qkey: 'Lebensohl07',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2H',
    qbad1: '2NT Lebensohl',
    qbad2: '3H',
    qbad3: 'Pass',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger02']
  },
  {
    qid: 343,
    qowner: 'public',
    qkey: 'Lebensohl08',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2NT',
    qbad1: '2H',
    qbad2: '3H',
    qbad3: 'Pass',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger02']
  },
  {
    qid: 344,
    qowner: 'public',
    qkey: 'Lebensohl09',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '3H',
    qbad3: '2NT',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger02']
  },
  {
    qid: 345,
    qowner: 'public',
    qkey: 'Lebensohl10',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3H',
    qbad1: '2NT Lebensohl',
    qbad2: '2H',
    qbad3: '3NT',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger02']
  },
  {
    qid: 346,
    qowner: 'public',
    qkey: 'Lebensohl11',
    qdetail: 'After the following bidding, what does 3D by you mean ?',
    qcorrect: 'Cue bid stayman',
    qbad1: 'Has a diamond stopper',
    qbad2: 'Ask for a diamond stopper',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 347,
    qowner: 'public',
    qkey: 'Lebensohl12',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3S',
    qbad1: '3NT',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 348,
    qowner: 'public',
    qkey: 'Lebensohl13',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3NT',
    qbad1: 'Pass',
    qbad2: '4C',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 349,
    qowner: 'public',
    qkey: 'Lebensohl14',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2NT',
    qbad1: '2S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 350,
    qowner: 'public',
    qkey: 'Lebensohl15',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3C',
    qbad1: 'Pass',
    qbad2: '3S',
    qbad3: '3H',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 351,
    qowner: 'public',
    qkey: 'Lebensohl16',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3H',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 352,
    qowner: 'public',
    qkey: 'Lebensohl17',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '4S',
    qbad1: '3NT',
    qbad2: '4C',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 353,
    qowner: 'public',
    qkey: 'Lebensohl18',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3S',
    qbad1: 'Pass',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 354,
    qowner: 'public',
    qkey: 'Lebensohl19',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3NT',
    qbad1: '4C',
    qbad2: '4H',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 355,
    qowner: 'public',
    qkey: 'Lebensohl20',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '2H',
    qbad3: '3NT',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 356,
    qowner: 'public',
    qkey: 'Lebensohl21',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3C',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 357,
    qowner: 'public',
    qkey: 'Lebensohl22',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3D',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 358,
    qowner: 'public',
    qkey: 'Lebensohl23',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3H',
    qbad1: '3NT',
    qbad2: '4H',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 359,
    qowner: 'public',
    qkey: 'Lebensohl24',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3H',
    qbad1: '2S',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 360,
    qowner: 'public',
    qkey: 'Lebensohl25',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger03']
  },
  {
    qid: 361,
    qowner: 'public',
    qkey: 'Lebensohl26',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3NT',
    qbad1: '2NT',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 362,
    qowner: 'public',
    qkey: 'Lebensohl27',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '5C',
    qbad1: 'Pass',
    qbad2: '4C',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 363,
    qowner: 'public',
    qkey: 'Lebensohl28',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '2NT',
    qbad1: 'Double',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 364,
    qowner: 'public',
    qkey: 'Lebensohl29',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3NT',
    qbad1: '4C',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 365,
    qowner: 'public',
    qkey: 'Lebensohl30',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '3NT',
    qbad1: '3C',
    qbad2: 'Double',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 366,
    qowner: 'public',
    qkey: 'Lebensohl31',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '4D',
    qbad1: 'Pass',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger04']
  },
  {
    qid: 367,
    qowner: 'public',
    qkey: 'Lebensohl32',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: 'Double',
    qbad1: '2NT',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger05']
  },
  {
    qid: 368,
    qowner: 'public',
    qkey: 'Lebensohl33',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '4H',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger05']
  },
  {
    qid: 369,
    qowner: 'public',
    qkey: 'Lebensohl34',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: 'Double',
    qbad1: '3C Styman',
    qbad2: '3H',
    qbad3: '3D',
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger05']
  },
  {
    qid: 370,
    qowner: 'public',
    qkey: 'Lebensohl35',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: 'Double',
    qbad1: 'Pass',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger05']
  },
  {
    qid: 371,
    qowner: 'public',
    qkey: 'Lebensohl36',
    qdetail: 'After the following bidding, what is your bid ?',
    qcorrect: '4H',
    qbad1: 'Pass',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'Lebensohl',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['LebensohlMarkHugger05']
  },
  {
    qid: 372,
    qowner: 'NZBridge',
    qkey: 'NZBStayman01',
    qdetail: 'What is your bid ?',
    qcorrect: '2S',
    qbad1: '2D',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 373,
    qowner: 'NZBridge',
    qkey: 'NZBStayman02',
    qdetail: 'What is your bid ?',
    qcorrect: '2H',
    qbad1: '2D',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 374,
    qowner: 'NZBridge',
    qkey: 'NZBStayman03',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 375,
    qowner: 'NZBridge',
    qkey: 'NZBStayman04',
    qdetail: 'What is your bid ?',
    qcorrect: '2S',
    qbad1: 'Pass',
    qbad2: '2D',
    qbad3: '2NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 377,
    qowner: 'NZBridge',
    qkey: 'NZBStayman05',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '3NT',
    qbad1: 'Pass',
    qbad2: '3S',
    qbad3: '3D',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 378,
    qowner: 'NZBridge',
    qkey: 'NZBStayman06',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '4S',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: 'Pass',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 379,
    qowner: 'NZBridge',
    qkey: 'NZBStayman07',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: 'Pass',
    qbad1: '3NT',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 380,
    qowner: 'NZBridge',
    qkey: 'NZBStayman08',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '4S',
    qbad1: '3NT',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 381,
    qowner: 'NZBridge',
    qkey: 'NZBStayman09',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '2S',
    qbad1: '3S',
    qbad2: '2H',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 382,
    qowner: 'NZBridge',
    qkey: 'NZBStayman10',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '2NT',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: '3NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 383,
    qowner: 'NZBridge',
    qkey: 'NZBStayman11',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '3S',
    qbad1: '2NT',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 384,
    qowner: 'NZBridge',
    qkey: 'NZBStayman12',
    qdetail: "What is your re-bid after partner's response ?",
    qcorrect: '3NT',
    qbad1: '2H',
    qbad2: '3D',
    qbad3: 'Pass',
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 385,
    qowner: 'NZBridge',
    qkey: 'NZBStayman13',
    qdetail: 'What is your bid ?',
    qcorrect: '3C',
    qbad1: 'Pass',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 386,
    qowner: 'NZBridge',
    qkey: 'NZBStayman14',
    qdetail: 'What is your bid ?',
    qcorrect: '3NT',
    qbad1: 'Pass',
    qbad2: '3C',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 387,
    qowner: 'NZBridge',
    qkey: 'NZBStayman15',
    qdetail: 'What is your response to partners 1NT overcall ?',
    qcorrect: '2C',
    qbad1: 'Pass',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 388,
    qowner: 'NZBridge',
    qkey: 'NZBStayman16',
    qdetail: 'What is your response to partners 1NT overcall ?',
    qcorrect: 'Pass',
    qbad1: '2C',
    qbad2: '3C',
    qbad3: null,
    qgroup1: 'NZBIMP01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBIMP01N', 'NZBIMP01Q']
  },
  {
    qid: 401,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer01',
    qdetail: 'Your partner opens 1NT. What is your response ?',
    qcorrect: '2H',
    qbad1: 'Pass',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 402,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer02',
    qdetail: 'Your partner opens 1NT. What is your response ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 403,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer03',
    qdetail: 'Your partner opens 1NT. What is your response ?',
    qcorrect: '2NT',
    qbad1: '3C',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 404,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer04',
    qdetail: 'Your partner opens 1NT. What is your response ?',
    qcorrect: '2H',
    qbad1: '3S',
    qbad2: 'Pass',
    qbad3: null,
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 405,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer05',
    qdetail: 'Your partner opens 1NT. What is your response ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '3H',
    qbad3: '3D',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 406,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer06',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: 'Pass',
    qbad1: '2NT',
    qbad2: '3S',
    qbad3: null,
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 407,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer07',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '3D',
    qbad1: '3H',
    qbad2: '2NT',
    qbad3: '3NT',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 408,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer08',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: 'Pass',
    qbad1: '5C',
    qbad2: '3NT',
    qbad3: '4C',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 409,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer09',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: '3NT',
    qbad3: null,
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 410,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer10',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '2NT',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: '4H',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 411,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer11',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '4H',
    qbad1: '3NT',
    qbad2: '3H',
    qbad3: 'Pass',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 412,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer12',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '3NT',
    qbad3: '3C',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 413,
    qowner: 'NZBridge',
    qkey: 'NZBTransfer13',
    qdetail: 'What is your next bid with the following hand ?',
    qcorrect: '3NT',
    qbad1: '2NT',
    qbad2: '3S',
    qbad3: '3H',
    qgroup1: 'NZBINT01',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT01N', 'NZBINT01Q']
  },
  {
    qid: 415,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood01',
    qdetail: 'What is your bid?',
    qcorrect: '4NT',
    qbad1: '4C',
    qbad2: '4H',
    qbad3: '3S',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 416,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood02',
    qdetail: 'What is your bid?',
    qcorrect: '4H',
    qbad1: '4C',
    qbad2: '4NT',
    qbad3: '3S',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 417,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood03',
    qdetail: 'What is your bid?',
    qcorrect: '5D',
    qbad1: '5C',
    qbad2: 'Pass',
    qbad3: '5H',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 418,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood04',
    qdetail: 'What is your bid?',
    qcorrect: '4NT',
    qbad1: '4H',
    qbad2: '3H',
    qbad3: '3NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 419,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood05',
    qdetail: 'What is your bid?',
    qcorrect: '5H',
    qbad1: '5C',
    qbad2: '5D',
    qbad3: '5S',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 420,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood06',
    qdetail: 'What is your bid?',
    qcorrect: '7H or 7NT',
    qbad1: '7C',
    qbad2: 'Pass',
    qbad3: '6NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 421,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood07',
    qdetail: 'What is your bid?',
    qcorrect: '6S',
    qbad1: '5H',
    qbad2: '7S',
    qbad3: '5NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 422,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood08',
    qdetail: 'What is your bid?',
    qcorrect: '6S',
    qbad1: '6H',
    qbad2: '7S',
    qbad3: '6NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 423,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood09',
    qdetail: 'What is your bid?',
    qcorrect: '6S',
    qbad1: '5S',
    qbad2: '7S',
    qbad3: '5NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 424,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood10',
    qdetail: 'What is your bid?',
    qcorrect: '7NT',
    qbad1: '6S',
    qbad2: '7S',
    qbad3: '6NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 425,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood11',
    qdetail: 'What is your bid?',
    qcorrect: '7NT',
    qbad1: '6S',
    qbad2: '7S',
    qbad3: '6NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 426,
    qowner: 'NZBridge',
    qkey: 'NZBBlackwood12',
    qdetail: 'Partners 2D is 6 diamonds and 6-10 HCP.  What is your bid ?',
    qcorrect: '5S',
    qbad1: '6S',
    qbad2: '5NT',
    qbad3: '6NT',
    qgroup1: 'NZBIMP02',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP02N', 'NZBIMP02Q']
  },
  {
    qid: 427,
    qowner: 'Geo',
    qkey: 'Lesson01',
    qdetail: 'Which bid is stronger ?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 429,
    qowner: 'Geo',
    qkey: 'Lesson02',
    qdetail: 'Which bid is stronger ?',
    qcorrect: '4D',
    qbad1: '4H',
    qbad2: '3H',
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 430,
    qowner: 'Geo',
    qkey: 'Lesson03',
    qdetail:
      'What is the correct play by declarer South  in 4S after AH lead followed by KH ruffed ?',
    qcorrect: 'Finesse diamonds twice entering dummy with AS and 10S',
    qbad1: 'Take out 3 rounds of trumps to stop a ruff',
    qbad2: 'Take out 2 rounds of trumps to stop a ruff',
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 431,
    qowner: 'Geo',
    qkey: 'Lesson04',
    qdetail: 'What is your bid ?',
    qcorrect: '4D',
    qbad1: '2NT',
    qbad2: '3D Bergen (10/11)',
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 432,
    qowner: 'Geo',
    qkey: 'Lesson05',
    qdetail:
      'South is playing in NT and West leads 5S.  Should East duck the 2S played by dummy ?',
    qcorrect: 'No',
    qbad1: 'Yes',
    qbad2: null,
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 433,
    qowner: 'Geo',
    qkey: 'Lesson06',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: 'Double',
    qbad2: '3D',
    qbad3: null,
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 434,
    qowner: 'Geo',
    qkey: 'Lesson07',
    qdetail: 'What is your bid ?',
    qcorrect: '3NT',
    qbad1: 'Pass',
    qbad2: '5D',
    qbad3: '4D',
    qgroup1: 'Geo210316',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['Geo210316', 'None']
  },
  {
    qid: 435,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack01',
    qdetail: 'What is your bid ?',
    qcorrect: '2C',
    qbad1: '2S',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 436,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack02',
    qdetail: 'What is your bid ?',
    qcorrect: '2C',
    qbad1: '2S',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 437,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack03',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 438,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack04',
    qdetail: 'What is your bid ?',
    qcorrect: '3H',
    qbad1: '2H',
    qbad2: 'Pass',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 439,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack05',
    qdetail: 'What is your bid ?',
    qcorrect: '3NT',
    qbad1: '2D',
    qbad2: '2C',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 440,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack06',
    qdetail: 'What is your bid ?',
    qcorrect: '3C',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: 'Pass',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 441,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack07',
    qdetail: 'What is your bid ?',
    qcorrect: 'Ace Ask',
    qbad1: '3D',
    qbad2: '3NT',
    qbad3: '5D',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 442,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack08',
    qdetail: 'What is your bid ?',
    qcorrect: '3C',
    qbad1: '3D',
    qbad2: '3H',
    qbad3: '3S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 443,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack09',
    qdetail: 'What is your bid ?',
    qcorrect: '4S',
    qbad1: '3NT',
    qbad2: '3C',
    qbad3: '3S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 444,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack10',
    qdetail: 'What is your bid ?',
    qcorrect: '4H',
    qbad1: '3NT',
    qbad2: '3H',
    qbad3: '3S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 445,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack11',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: '3NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 446,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack12',
    qdetail: 'What is your bid ?',
    qcorrect: '2NT',
    qbad1: '3C',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 447,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack13',
    qdetail: 'What is your bid ?',
    qcorrect: '2S',
    qbad1: '2D',
    qbad2: '3D',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 448,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack14',
    qdetail: 'What is your bid ?',
    qcorrect: '2H',
    qbad1: '2S',
    qbad2: '2D',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 449,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack15',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '2NT',
    qbad3: '2S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 450,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack16',
    qdetail: 'What is your bid ?',
    qcorrect: '2S',
    qbad1: '2D',
    qbad2: '2H',
    qbad3: '2NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 451,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack17',
    qdetail: 'What is your bid ?',
    qcorrect: '2D',
    qbad1: '2D',
    qbad2: '2H',
    qbad3: '2S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 452,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack18',
    qdetail: 'What is your bid ?',
    qcorrect: '2H',
    qbad1: '2NT',
    qbad2: '3H',
    qbad3: '3NT',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 453,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack19',
    qdetail: 'What is your bid ?',
    qcorrect: '2NT',
    qbad1: 'Pass',
    qbad2: '2H',
    qbad3: '2D',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 454,
    qowner: 'NZBridge',
    qkey: 'NZBCheckBack20',
    qdetail: 'What is your bid ?',
    qcorrect: '2S',
    qbad1: '2NT',
    qbad2: '3NT',
    qbad3: '3S',
    qgroup1: 'NZBINT02',
    qgroup2: 'Bidding',
    qgroup3: 'None',
    qrefs: ['NZBINT02N', 'NZBINT02Q']
  },
  {
    qid: 457,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX01',
    qdetail:
      'Your partner opens 1NT and is doubled (penalty).  What is your response?',
    qcorrect: 'XX',
    qbad1: 'Pass',
    qbad2: '2H',
    qbad3: '2S',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 458,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX02',
    qdetail:
      'Your partner opens 1NT and is doubled (penalty).  What is your response?',
    qcorrect: '2D',
    qbad1: 'XX',
    qbad2: '2H',
    qbad3: '2C',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 459,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX03',
    qdetail:
      'Your partner opens 1NT and is doubled (penalty).  What is your response?',
    qcorrect: 'PASS',
    qbad1: '2C',
    qbad2: 'XX',
    qbad3: '2NT',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 460,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX04',
    qdetail:
      'Your partner opens 1NT and is doubled (penalty).  What is your response?',
    qcorrect: 'PASS',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: 'XX',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 461,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX05',
    qdetail:
      'Your partner opens 1NT and is doubled (penalty).  What is your response?',
    qcorrect: '2H',
    qbad1: '2S',
    qbad2: '2C',
    qbad3: 'Pass',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 462,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX06',
    qdetail: 'What is your next bid?',
    qcorrect: '2S',
    qbad1: 'Pass',
    qbad2: '2H',
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 463,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX07',
    qdetail: 'What is your next bid?',
    qcorrect: 'Pass',
    qbad1: '2NT',
    qbad2: null,
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 464,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX08',
    qdetail: 'What is your next bid?',
    qcorrect: 'Pass',
    qbad1: '2S',
    qbad2: null,
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 465,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX09',
    qdetail: 'You open 1NT.  What is your next bid?',
    qcorrect: '2C',
    qbad1: 'Pass',
    qbad2: '2H',
    qbad3: '2S',
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 466,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX10',
    qdetail: 'You open 1NT.  What is your next bid?',
    qcorrect: 'PASS',
    qbad1: '2H',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 467,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX11',
    qdetail: 'You open 1NT.  What is your next bid?',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: '2NT',
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 468,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX12',
    qdetail: 'You open 1NT.  What is your next bid?',
    qcorrect: '2D',
    qbad1: 'PASS',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 469,
    qowner: 'NZBridge',
    qkey: 'NZB1NTX13',
    qdetail: 'You open 1NT.  What is your next bid?',
    qcorrect: 'PASS',
    qbad1: '2D',
    qbad2: '2S',
    qbad3: null,
    qgroup1: 'NZBINT03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT03N', 'NZBINT03Q']
  },
  {
    qid: 470,
    qowner: 'NZBridge',
    qkey: 'NZBPlay01',
    qdetail:
      'How do you play the spade suit for the number of tricks indicated? You have entries in other suits to both hands.',
    qcorrect: 'Lead towards the spade honours TWICE, hoping South has the Ace',
    qbad1: 'Play 7 and the Ace will likely be played',
    qbad2: 'Lead towards the spade honours ONCE, hoping South has the Ace',
    qbad3: null,
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 471,
    qowner: 'NZBridge',
    qkey: 'NZBPlay02',
    qdetail:
      'How do you play the spade suit for the number of tricks indicated? You have entries in other suits to both hands.',
    qcorrect: 'Lead towards the ♠Q (finesse) hoping South has the ♠K',
    qbad1: 'Play the Ace and hope the King drops',
    qbad2: 'Play the Queen, it will not be covered',
    qbad3: 'Avoid the suit, they will lead to you',
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 472,
    qowner: 'NZBridge',
    qkey: 'NZBPlay03',
    qdetail:
      'How do you play the spade suit for the number of tricks indicated? You have entries in other suits to both hands.',
    qcorrect: 'Take the spade finesse twice hoping North has the ♠K',
    qbad1: 'Play the Ace and hope the King drops',
    qbad2: 'Play the Jack, it will not be covered',
    qbad3: 'Avoid the suit, they will lead to you',
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 473,
    qowner: 'NZBridge',
    qkey: 'NZBPlay04',
    qdetail: 'Which suit do you play on first',
    qcorrect: 'Spades',
    qbad1: 'Heart',
    qbad2: 'Diamonds',
    qbad3: 'Clubs',
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 475,
    qowner: 'NZBridge',
    qkey: 'NZBPlay05',
    qdetail: 'How do you play the spade suit 5 tricks?',
    qcorrect: 'Finesse South for the ♠K, by leading the ♠Q first',
    qbad1:
      'Finesse South for the ♠K, by leading the ♠Q first, cover with the Ace if the king does not show',
    qbad2:
      'Finesse South for the ♠K, by leading the ♠J first, cover with the Ace if the king does not show',
    qbad3:
      'Finesse South for the ♠K, by leading the ♠T first, cover with the Ace if the king does not show',
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 476,
    qowner: 'NZBridge',
    qkey: 'NZBPlay06',
    qdetail: 'How do you play the spade suit 4 tricks?',
    qcorrect: 'Cash the ♠K first, then finesse the ♠Q',
    qbad1: 'Play AS followed by ♠K',
    qbad2: 'Play KS followed by ♠A',
    qbad3: null,
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 477,
    qowner: 'NZBridge',
    qkey: 'NZBPlay07',
    qdetail: 'How do you play the spade suit 3 tricks?',
    qcorrect:
      'Lead towards the ♠10. If it wins, return to hand and repeat the finesse',
    qbad1:
      'Lead towards the ♠K. If it wins, return to hand and repeat the finesse',
    qbad2: 'Play the ♠T',
    qbad3: null,
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 478,
    qowner: 'NZBridge',
    qkey: 'NZBPlay08',
    qdetail:
      'You are in 1NT.  After winning the Q diamond lead with the Ace.  What is your play.',
    qcorrect: 'Ace clubs followed by 7 clubs to K clubs.',
    qbad1: '7 clubs to K clubs.',
    qbad2: 'King of diamonds',
    qbad3: null,
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 479,
    qowner: 'NZBridge',
    qkey: 'NZBPlay09',
    qdetail:
      'You are declarer in 3NT. At trick one, North leads ♠5 and South plays ♠Q. What is your plan ? ',
    qcorrect: 'Play on diamonds, Ace then duck a diamond, then the King.',
    qbad1: 'Play on diamonds, Ace then King of diamonds, then small diamond',
    qbad2: 'Play on diamonds, King then finesse a diamond through the Ace.',
    qbad3: null,
    qgroup1: 'NZBIMP03',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBIMP03N', 'NZBIMP03Q']
  },
  {
    qid: 481,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT01',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: 'X',
    qbad1: '2NT',
    qbad2: '2S',
    qbad3: '3S',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 482,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT02',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '2NT',
    qbad1: 'X',
    qbad2: '3D',
    qbad3: 'PASS',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 483,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT03',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '2NT',
    qbad1: 'X',
    qbad2: '2S',
    qbad3: '3S',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 484,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT04',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: 'PASS',
    qbad1: '2NT',
    qbad2: '3NT',
    qbad3: 'X',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 485,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT05',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '2S',
    qbad1: '2NT',
    qbad2: '3S',
    qbad3: 'X',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 486,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT06',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '3H',
    qbad1: 'X',
    qbad2: '2NT',
    qbad3: '3D',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 487,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT07',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '3NT',
    qbad1: 'X',
    qbad2: '2NT',
    qbad3: '3C',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 488,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT08',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '3S',
    qbad1: 'X',
    qbad2: '4S',
    qbad3: '2NT',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 489,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT09',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '3NT',
    qbad1: '3S',
    qbad2: '4H',
    qbad3: 'PASS',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 490,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT10',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '4H',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: 'PASS',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 491,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT11',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '4H',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: 'PASS',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 492,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT12',
    qdetail: 'What is your bid after the following auction?',
    qcorrect: '4H',
    qbad1: '3S',
    qbad2: '4NT',
    qbad3: '3NT',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 493,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT13',
    qdetail:
      'What is your bid after the following auction, where 2C is both majors?',
    qcorrect: 'X',
    qbad1: '2NT',
    qbad2: '3NT',
    qbad3: 'PASS',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 494,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT14',
    qdetail:
      'What is your bid after the following auction, where 2C is both majors?',
    qcorrect: '2NT',
    qbad1: '3C',
    qbad2: 'PASS',
    qbad3: 'X',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 495,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT15',
    qdetail:
      'What is your bid after the following auction, where 2C is both majors?',
    qcorrect: '3D',
    qbad1: '2NT',
    qbad2: '3NT',
    qbad3: 'X',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 496,
    qowner: 'NZBridge',
    qkey: 'NZB1NTINT16',
    qdetail:
      'What is your bid after the following auction, where 2C is both majors?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '2NT',
    qbad3: '3NT',
    qgroup1: 'NZBINT04',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT04N', 'NZBINT04Q']
  },
  {
    qid: 497,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY01',
    qdetail: 'What is your bid after the opposition open 1NT?',
    qcorrect: '2C',
    qbad1: '2S',
    qbad2: '2D',
    qbad3: '2H',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 498,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY02',
    qdetail: 'What is your bid after the opposition open 1NT?',
    qcorrect: '3C',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 499,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY03',
    qdetail: 'What is your bid after the opposition open 1NT?',
    qcorrect: 'PASS',
    qbad1: '2H',
    qbad2: '2C',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 500,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY04',
    qdetail: 'What is your bid after the opposition open 1NT?',
    qcorrect: 'X',
    qbad1: '2H',
    qbad2: '2C',
    qbad3: '3H',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 501,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY05',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: 'PASS',
    qbad1: '2H',
    qbad2: '2C',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 502,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY06',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: '',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 503,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY07',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: 'PASS',
    qbad1: '2C',
    qbad2: '2H',
    qbad3: '2S',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 504,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY08',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: 'PASS',
    qbad1: '2D',
    qbad2: '2S',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 505,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY09',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '2S',
    qbad1: '2D',
    qbad2: '',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 506,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY10',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '2D',
    qbad1: 'PASS',
    qbad2: '',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 507,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY11',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: 'PASS',
    qbad1: '3C',
    qbad2: '2H',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 508,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY13',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '4H',
    qbad1: '2S',
    qbad2: '3H',
    qbad3: '3S',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 509,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY14',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '2NT',
    qbad1: '3C',
    qbad2: '2S',
    qbad3: '3NT',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 510,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY12',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '2H',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 511,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY15',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: 'PASS',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: '',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 512,
    qowner: 'NZBridge',
    qkey: 'NZBLANDY16',
    qdetail: 'What is your bid after the following auction ? ',
    qcorrect: '3C',
    qbad1: 'PASS',
    qbad2: '4C',
    qbad3: '3NT',
    qgroup1: 'NZBINT05',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT05N', 'NZBINT05Q']
  },
  {
    qid: 513,
    qowner: 'NZBridge',
    qkey: 'NZBRESP01',
    qdetail: 'What do you bid with the following hands?',
    qcorrect: 'X',
    qbad1: '2D',
    qbad2: '2S',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 514,
    qowner: 'NZBridge',
    qkey: 'NZBRESP02',
    qdetail: 'What do you bid with the following hands?',
    qcorrect: '2S',
    qbad1: '2D',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 515,
    qowner: 'NZBridge',
    qkey: 'NZBRESP03',
    qdetail: 'What do you bid with the following hands?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '2D',
    qbad3: '2NT',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 516,
    qowner: 'NZBridge',
    qkey: 'NZBRESP04',
    qdetail: 'What do you bid with the following hands?',
    qcorrect: '2NT',
    qbad1: '2D',
    qbad2: 'X',
    qbad3: '2H',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 517,
    qowner: 'NZBridge',
    qkey: 'NZBRESP05',
    qdetail: 'What do you bid with the following hands?',
    qcorrect: '3C',
    qbad1: '2D',
    qbad2: 'PASS',
    qbad3: 'X',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 518,
    qowner: 'NZBridge',
    qkey: 'NZBRESP06',
    qdetail: 'What do you bid with the following hand (3D Weak)?',
    qcorrect: '3S',
    qbad1: 'X',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 519,
    qowner: 'NZBridge',
    qkey: 'NZBRESP07',
    qdetail: 'What do you bid with the following hand (3D Weak)?',
    qcorrect: '4C',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '3S',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 520,
    qowner: 'NZBridge',
    qkey: 'NZBRESP08',
    qdetail: 'What do you bid with the following hand (3D Weak)?',
    qcorrect: 'X',
    qbad1: '4S',
    qbad2: '3S',
    qbad3: 'PASS',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 521,
    qowner: 'NZBridge',
    qkey: 'NZBRESP09',
    qdetail: 'What do you bid with the following hand (3D Weak)?',
    qcorrect: '3NT',
    qbad1: '4C',
    qbad2: '3S',
    qbad3: '4S',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 522,
    qowner: 'NZBridge',
    qkey: 'NZBRESP10',
    qdetail: 'What do you bid with the following hand (3D Weak)?',
    qcorrect: '3NT',
    qbad1: '4C',
    qbad2: '3S',
    qbad3: '4S',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 523,
    qowner: 'NZBridge',
    qkey: 'NZBRESP11',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: 'X',
    qbad1: '2D',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 524,
    qowner: 'NZBridge',
    qkey: 'NZBRESP12',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 525,
    qowner: 'NZBridge',
    qkey: 'NZBRESP13',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '2H',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 526,
    qowner: 'NZBridge',
    qkey: 'NZBRESP14',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: 'PASS',
    qbad1: '2H',
    qbad2: '2D',
    qbad3: 'X',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 527,
    qowner: 'NZBridge',
    qkey: 'NZBRESP15',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '2C',
    qbad1: 'X',
    qbad2: 'PASS',
    qbad3: '2H',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 528,
    qowner: 'NZBridge',
    qkey: 'NZBRESP16',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: '3S',
    qbad3: '2C',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 529,
    qowner: 'NZBridge',
    qkey: 'NZBRESP17',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '1NT',
    qbad1: '2S',
    qbad2: 'PASS',
    qbad3: '2C',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 530,
    qowner: 'NZBridge',
    qkey: 'NZBRESP18',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: 'XX',
    qbad1: '1NT',
    qbad2: '2NT',
    qbad3: '3NT',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 531,
    qowner: 'NZBridge',
    qkey: 'NZBRESP19',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '4S',
    qbad1: '3S',
    qbad2: 'XX',
    qbad3: '2S',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 532,
    qowner: 'NZBridge',
    qkey: 'NZBRESP20',
    qdetail: 'What do you bid with the following hand (1NT 16-18)?',
    qcorrect: '2C',
    qbad1: 'PASS',
    qbad2: '2NT',
    qbad3: '2S',
    qgroup1: 'NZBINT06',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT06N', 'NZBINT06Q']
  },
  {
    qid: 533,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL01',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '3H',
    qbad1: '3C',
    qbad2: '4H',
    qbad3: '3D',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 534,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL02',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2C',
    qbad1: '3H',
    qbad2: '4H',
    qbad3: '3D',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 535,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL03',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '2C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 536,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL04',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '1NT',
    qbad1: '1S',
    qbad2: 'PASS',
    qbad3: '2NT',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 537,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL05',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '4H',
    qbad1: '4C',
    qbad2: '2D',
    qbad3: '3H',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 538,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL06',
    qdetail: 'What do you bid with the following hand (VUL)?',
    qcorrect: '3S',
    qbad1: 'PASS',
    qbad2: '4C',
    qbad3: '3NT',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 539,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL07',
    qdetail: 'What do you bid with the following hand (NON-VUL)?',
    qcorrect: '4C',
    qbad1: 'PASS',
    qbad2: '3H',
    qbad3: '',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 540,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL08',
    qdetail: 'What do you bid with the following hand (VUL)?',
    qcorrect: '3NT',
    qbad1: 'PASS',
    qbad2: '5C',
    qbad3: '3H',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 541,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL09',
    qdetail: 'What do you bid with the following hand (NON-VUL)?',
    qcorrect: 'PASS',
    qbad1: '3H',
    qbad2: '3S',
    qbad3: '',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 542,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL10',
    qdetail: 'What do you bid with the following hand (VUL)?',
    qcorrect: '3D',
    qbad1: '3S',
    qbad2: '4C',
    qbad3: '5C',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 543,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL11',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '3NT',
    qbad1: '2NT',
    qbad2: '2H',
    qbad3: '3C',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 544,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL12',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2H',
    qbad1: '2S',
    qbad2: 'PASS',
    qbad3: '2C',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 545,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL13',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '3D',
    qbad1: '2D',
    qbad2: '3NT',
    qbad3: '2S',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 546,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL14',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2C',
    qbad1: '2S',
    qbad2: '2H',
    qbad3: '3NT',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 547,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL15',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2S',
    qbad1: '2NT',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 548,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL16',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'X',
    qbad1: '2H',
    qbad2: '2C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 549,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL17',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2H',
    qbad1: 'X',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 550,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL18',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '1NT',
    qbad1: '2H',
    qbad2: '2D',
    qbad3: 'X',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 551,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL19',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2C',
    qbad1: 'PASS',
    qbad2: '2H',
    qbad3: 'X',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 552,
    qowner: 'NZBridge',
    qkey: 'NZOVERCALL20',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '2NT',
    qbad1: '1NT',
    qbad2: '2H',
    qbad3: '2C',
    qgroup1: 'NZBINT07',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT07N', 'NZBINT07Q']
  },
  {
    qid: 553,
    qowner: 'NZBridge',
    qkey: 'NZBMICH01',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '2D',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 554,
    qowner: 'NZBridge',
    qkey: 'NZBMICH02',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: 'X',
    qbad1: '2D',
    qbad2: '2H',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 555,
    qowner: 'NZBridge',
    qkey: 'NZBMICH03',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '2NT',
    qbad1: '2C',
    qbad2: '2H',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 556,
    qowner: 'NZBridge',
    qkey: 'NZBMICH04',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '1H',
    qbad1: '2C',
    qbad2: '2D',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 557,
    qowner: 'NZBridge',
    qkey: 'NZBMICH05',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '1S',
    qbad1: '2C',
    qbad2: '2D',
    qbad3: '2S',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 558,
    qowner: 'NZBridge',
    qkey: 'NZBMICH06',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '2D',
    qbad1: '1H',
    qbad2: '2C',
    qbad3: 'X',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 559,
    qowner: 'NZBridge',
    qkey: 'NZBMICH07',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: 'PASS',
    qbad1: '2D',
    qbad2: '2C',
    qbad3: '2H',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 560,
    qowner: 'NZBridge',
    qkey: 'NZBMICH08',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: 'X',
    qbad1: '2D',
    qbad2: '2C',
    qbad3: '2H',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 561,
    qowner: 'NZBridge',
    qkey: 'NZBMICH09',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '2H',
    qbad1: '2D',
    qbad2: '2C',
    qbad3: '3H',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 562,
    qowner: 'NZBridge',
    qkey: 'NZBMICH10',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '2D',
    qbad1: '2C',
    qbad2: '2H',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 563,
    qowner: 'NZBridge',
    qkey: 'NZBMICH11',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '3C',
    qbad1: 'PASS',
    qbad2: '2NT',
    qbad3: '3D',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 564,
    qowner: 'NZBridge',
    qkey: 'NZBMICH12',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '3S',
    qbad1: '2S',
    qbad2: '4S',
    qbad3: '',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 565,
    qowner: 'NZBridge',
    qkey: 'NZBMICH13',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '2S',
    qbad1: '2NT',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 566,
    qowner: 'NZBridge',
    qkey: 'NZBMICH14',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '2NT',
    qbad1: '3D',
    qbad2: '3NT',
    qbad3: '3C',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 567,
    qowner: 'NZBridge',
    qkey: 'NZBMICH15',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: '3NT',
    qbad3: '2NT',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 568,
    qowner: 'NZBridge',
    qkey: 'NZBMICH16',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '3D',
    qbad1: 'PASS',
    qbad2: '3H',
    qbad3: '3C',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 569,
    qowner: 'NZBridge',
    qkey: 'NZBMICH17',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: '5C',
    qbad1: 'PASS',
    qbad2: '3C',
    qbad3: '4C',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 570,
    qowner: 'NZBridge',
    qkey: 'NZBMICH18',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: 'XX',
    qbad1: '3H',
    qbad2: '3C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 571,
    qowner: 'NZBridge',
    qkey: 'NZBMICH19',
    qdetail: 'What do you bid with the following hand (VUL)? ',
    qcorrect: '3D',
    qbad1: 'PASS',
    qbad2: '4D',
    qbad3: '',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 572,
    qowner: 'NZBridge',
    qkey: 'NZBMICH20',
    qdetail: 'What do you bid with the following hand (NON-VUL)? ',
    qcorrect: 'PASS',
    qbad1: '3D',
    qbad2: '3H',
    qbad3: 'XX',
    qgroup1: 'NZBINT08',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT08N', 'NZBINT08Q']
  },
  {
    qid: 573,
    qowner: 'NZBridge',
    qkey: 'NZBHLB01',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'PASS',
    qbad1: '5S',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 574,
    qowner: 'NZBridge',
    qkey: 'NZBHLB02',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5S',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 575,
    qowner: 'NZBridge',
    qkey: 'NZBHLB03',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'X',
    qbad1: 'PASS',
    qbad2: '5S',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 576,
    qowner: 'NZBridge',
    qkey: 'NZBHLB04',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5S',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 577,
    qowner: 'NZBridge',
    qkey: 'NZBHLB05',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'PASS',
    qbad1: '5C',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 578,
    qowner: 'NZBridge',
    qkey: 'NZBHLB06',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '4S',
    qbad1: '5C',
    qbad2: 'X',
    qbad3: 'PASS',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 579,
    qowner: 'NZBridge',
    qkey: 'NZBHLB07',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5C',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 580,
    qowner: 'NZBridge',
    qkey: 'NZBHLB08',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'X',
    qbad1: 'PASS',
    qbad2: '5C',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 581,
    qowner: 'NZBridge',
    qkey: 'NZBHLB09',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'PASS',
    qbad1: '5D',
    qbad2: '5C',
    qbad3: 'X',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 582,
    qowner: 'NZBridge',
    qkey: 'NZBHLB10',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5H',
    qbad1: 'PASS',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 583,
    qowner: 'NZBridge',
    qkey: 'NZBHLB11',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5C',
    qbad1: '5D',
    qbad2: 'X',
    qbad3: 'PASS',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 584,
    qowner: 'NZBridge',
    qkey: 'NZBHLB12',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'X',
    qbad1: '5D',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 585,
    qowner: 'NZBridge',
    qkey: 'NZBHLB13',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'PASS',
    qbad1: '5S',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 586,
    qowner: 'NZBridge',
    qkey: 'NZBHLB14',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'PASS',
    qbad1: '5S',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 587,
    qowner: 'NZBridge',
    qkey: 'NZBHLB15',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: 'X',
    qbad1: '5S',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 588,
    qowner: 'NZBridge',
    qkey: 'NZBHLB16',
    qdetail: 'What do you bid with the following hand?',
    qcorrect: '5S',
    qbad1: 'X',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT09',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT09N', 'NZBINT09Q']
  },
  {
    qid: 589,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE01',
    qdetail: 'What do you bid with the following hand (All VUL)?',
    qcorrect: 'X',
    qbad1: '2S',
    qbad2: '2NT',
    qbad3: 'PASS',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 590,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE02',
    qdetail: 'What do you bid with the following hand (All VUL)?',
    qcorrect: '3D',
    qbad1: 'X',
    qbad2: '2NT',
    qbad3: '3C',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 591,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE03',
    qdetail: 'What do you bid with the following hand (All VUL)?',
    qcorrect: '2NT',
    qbad1: 'X',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 592,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE04',
    qdetail: 'What do you bid with the following hand (All VUL)?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '3C',
    qbad3: '3D',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 593,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE05',
    qdetail: 'What do you bid with the following hand (All VUL)?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 594,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE06',
    qdetail: 'What do you bid with the following hand (N/S are VUL)?',
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 595,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE07',
    qdetail: 'What do you bid with the following hand (N/S are VUL)?',
    qcorrect: '2NT',
    qbad1: '3H',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 596,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE08',
    qdetail: 'What do you bid with the following hand (N/S are VUL)?',
    qcorrect: '3C',
    qbad1: '2NT',
    qbad2: 'PASS',
    qbad3: '3D',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 597,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE09',
    qdetail: 'What do you bid with the following hand (N/S are VUL)?',
    qcorrect: '3NT',
    qbad1: '2NT',
    qbad2: '3C',
    qbad3: '3D',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 598,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE10',
    qdetail: 'What do you bid with the following hand (N/S are VUL)?',
    qcorrect: 'PASS',
    qbad1: '2NT',
    qbad2: '3NT',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 599,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE11',
    qdetail: 'What action do you take with the following hand (E/W areVUL)?',
    qcorrect: '4S',
    qbad1: '3S',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 600,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE12',
    qdetail: 'What action do you take with the following hand (E/W areVUL)?',
    qcorrect: '4D',
    qbad1: '3H',
    qbad2: '4H',
    qbad3: '4S',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 601,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE13',
    qdetail: 'What action do you take with the following hand (E/W areVUL)?',
    qcorrect: 'PASS',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: '4C',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 602,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE14',
    qdetail: 'What action do you take with the following hand (E/W areVUL)?',
    qcorrect: '3NT',
    qbad1: '3S',
    qbad2: '4C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 603,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE15',
    qdetail: 'What action do you take with the following hand (None VUL)?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '4C',
    qbad3: '4NT',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 604,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE16',
    qdetail: 'What action do you take with the following hand (None VUL)?',
    qcorrect: '4NT',
    qbad1: 'X',
    qbad2: '5D',
    qbad3: '5H',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 605,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE17',
    qdetail: 'What action do you take with the following hand (None VUL)?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '5D',
    qbad3: '',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 606,
    qowner: 'NZBridge',
    qkey: 'NZBDEFPRE18',
    qdetail: 'What action do you take with the following hand (None VUL)?',
    qcorrect: 'X',
    qbad1: 'PASS',
    qbad2: '5D',
    qbad3: '4NT',
    qgroup1: 'NZBINT10',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT10N', 'NZBINT10Q']
  },
  {
    qid: 607,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D01',
    qdetail: 'What do you bid?',
    qcorrect: '3H',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: '3C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 608,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D02',
    qdetail: 'What do you bid?',
    qcorrect: '3NT',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: '2NT',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 609,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D03',
    qdetail: 'What do you bid?',
    qcorrect: '2NT',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: '3NT',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 610,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D04',
    qdetail: 'What do you bid?',
    qcorrect: '2H',
    qbad1: 'PASS',
    qbad2: '3D',
    qbad3: '',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 611,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D05',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: '2H',
    qbad2: '2S',
    qbad3: 'PASS',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 612,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D06',
    qdetail: 'What do you bid?',
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '3NT',
    qbad3: 'PASS',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 613,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D07',
    qdetail: 'What do you bid?',
    qcorrect: '4C',
    qbad1: '3C',
    qbad2: '3NT',
    qbad3: '5C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 614,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D08',
    qdetail: 'What do you bid?',
    qcorrect: '3D',
    qbad1: '3S',
    qbad2: '4S',
    qbad3: '3C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 615,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D09',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: '3H',
    qbad2: '3NT',
    qbad3: '4H',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 616,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D10',
    qdetail: 'What do you bid?',
    qcorrect: '3NT',
    qbad1: '4NT',
    qbad2: '5NT',
    qbad3: '6NT',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 617,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D11',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '2NT',
    qbad3: '2S',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 618,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D12',
    qdetail: 'What do you bid?',
    qcorrect: 'X',
    qbad1: '2S',
    qbad2: '3S',
    qbad3: 'PASS',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 620,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D13',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: '2S',
    qbad2: 'X',
    qbad3: 'PASS',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 621,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D14',
    qdetail: 'What do you bid?',
    qcorrect: '2NT',
    qbad1: 'X',
    qbad2: '3C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 622,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D15',
    qdetail: 'What do you bid?',
    qcorrect: '2H',
    qbad1: 'X',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 623,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D16',
    qdetail: 'What do you bid?',
    qcorrect: '2NT',
    qbad1: 'PASS',
    qbad2: '2H',
    qbad3: '2S',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 624,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D17',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: '3D',
    qbad2: 'PASS',
    qbad3: '2NT',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 625,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D18',
    qdetail: 'What do you bid?',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: '2NT',
    qbad3: '3C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 626,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D19',
    qdetail: 'What do you bid?',
    qcorrect: '3H',
    qbad1: '4H',
    qbad2: '2NT',
    qbad3: '3C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 627,
    qowner: 'NZBridge',
    qkey: 'NZBMULTI2D20',
    qdetail: 'What do you bid?',
    qcorrect: '2H',
    qbad1: '2NT',
    qbad2: 'PASS',
    qbad3: '3C',
    qgroup1: 'NZBINT11',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT11N', 'NZBINT11Q']
  },
  {
    qid: 628,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP01',
    qdetail: 'What do you bid?',
    qcorrect: '2S',
    qbad1: 'PASS',
    qbad2: '2NT',
    qbad3: '',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 629,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP02',
    qdetail: 'What do you bid?',
    qcorrect: '2NT',
    qbad1: 'PASS',
    qbad2: '3NT',
    qbad3: '4H',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 630,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP03',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: 'PASS',
    qbad2: '3D',
    qbad3: '2S',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 631,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP04',
    qdetail: 'What do you bid?',
    qcorrect: '3H',
    qbad1: 'PASS',
    qbad2: '4H',
    qbad3: '',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 632,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP05',
    qdetail: 'What do you bid?',
    qcorrect: '3D',
    qbad1: '3S',
    qbad2: '3NT',
    qbad3: '',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 633,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP06',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: 'PASS',
    qbad2: '3D',
    qbad3: '3NT',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 634,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP07',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: '3S',
    qbad2: 'PASS',
    qbad3: '3NT',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 635,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP08',
    qdetail: 'What do you bid?',
    qcorrect: '3H',
    qbad1: '3S',
    qbad2: '3C',
    qbad3: 'PASS',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 636,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP09',
    qdetail: 'What do you bid?',
    qcorrect: '4H',
    qbad1: '3NT',
    qbad2: 'PASS',
    qbad3: '',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 637,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP10',
    qdetail: 'What do you bid?',
    qcorrect: '3NT',
    qbad1: 'PASS',
    qbad2: '3S',
    qbad3: '4D',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 638,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP11',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: 'PASS',
    qbad2: '3NT',
    qbad3: '4D',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 639,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP12',
    qdetail: 'What do you bid?',
    qcorrect: '4NT',
    qbad1: '4H',
    qbad2: '3NT',
    qbad3: '4C',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 640,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP13',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: 'X',
    qbad2: '3S',
    qbad3: '3D',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 641,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP14',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: '4S',
    qbad2: 'X',
    qbad3: '',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 642,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP15',
    qdetail: 'What do you bid?',
    qcorrect: 'X',
    qbad1: '3NT',
    qbad2: '3S',
    qbad3: 'PASS',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 643,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP16',
    qdetail: 'What do you bid?',
    qcorrect: '4S',
    qbad1: 'X',
    qbad2: '3S',
    qbad3: '3H',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 644,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP17',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: 'PASS',
    qbad2: '3NT',
    qbad3: '3D',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 645,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP18',
    qdetail: 'What do you bid?',
    qcorrect: '3C',
    qbad1: '2NT',
    qbad2: 'XX',
    qbad3: 'PASS',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 646,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP19',
    qdetail: 'What do you bid?',
    qcorrect: '3D',
    qbad1: 'PASS',
    qbad2: '3C',
    qbad3: 'XX',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 647,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP20',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: '3S',
    qbad2: '2NT',
    qbad3: '3D',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 648,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP21',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: '3C',
    qbad2: '3NT',
    qbad3: '3H',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 649,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP22',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: '3D',
    qbad2: '2NT',
    qbad3: '3H',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 650,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP23',
    qdetail: 'What do you bid?',
    qcorrect: '3S',
    qbad1: '3H',
    qbad2: '3D',
    qbad3: 'PASS',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 651,
    qowner: 'NZBridge',
    qkey: 'NZBWEAK2RESP24',
    qdetail: 'What do you bid?',
    qcorrect: 'PASS',
    qbad1: '2NT',
    qbad2: '3C',
    qbad3: '3H',
    qgroup1: 'NZBINT12',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT12N', 'NZBINT12Q']
  },
  {
    qid: 652,
    qowner: 'NZBridge',
    qkey: 'NZBRKC01',
    qdetail: 'What is your bid?',
    qcorrect: '4C',
    qbad1: '2D',
    qbad2: '3S',
    qbad3: '4S',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 653,
    qowner: 'NZBridge',
    qkey: 'NZBRKC02',
    qdetail: 'What is your bid?',
    qcorrect: '2C',
    qbad1: '2S',
    qbad2: '2H',
    qbad3: '3S',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 654,
    qowner: 'NZBridge',
    qkey: 'NZBRKC03',
    qdetail: 'What is your bid?',
    qcorrect: '4H',
    qbad1: '4S',
    qbad2: '2D',
    qbad3: '3S',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 655,
    qowner: 'NZBridge',
    qkey: 'NZBRKC04',
    qdetail: 'What is your bid?',
    qcorrect: '4NT',
    qbad1: '4S',
    qbad2: '4C',
    qbad3: '2D',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 656,
    qowner: 'NZBridge',
    qkey: 'NZBRKC05',
    qdetail: 'What is your bid?',
    qcorrect: '4NT',
    qbad1: '4H',
    qbad2: '5H',
    qbad3: '4S',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 657,
    qowner: 'NZBridge',
    qkey: 'NZBRKC06',
    qdetail: 'What is your bid?',
    qcorrect: '4H',
    qbad1: '6H',
    qbad2: '4NT',
    qbad3: '5D',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 658,
    qowner: 'NZBridge',
    qkey: 'NZBRKC07',
    qdetail: 'What is your bid?',
    qcorrect: '4NT',
    qbad1: '5D',
    qbad2: '4H',
    qbad3: '6H',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 659,
    qowner: 'NZBridge',
    qkey: 'NZBRKC08',
    qdetail: 'What is your bid?',
    qcorrect: '4H',
    qbad1: '5D',
    qbad2: '4NT',
    qbad3: '4S',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 660,
    qowner: 'NZBridge',
    qkey: 'NZBRKC09',
    qdetail: 'What is your bid?',
    qcorrect: '5S',
    qbad1: '5H',
    qbad2: '5C',
    qbad3: '5D',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 661,
    qowner: 'NZBridge',
    qkey: 'NZBRKC10',
    qdetail: 'What is your bid?',
    qcorrect: '5',
    qbad1: '5H',
    qbad2: '5C',
    qbad3: '5D',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 662,
    qowner: 'NZBridge',
    qkey: 'NZBRKC11',
    qdetail: 'What is your bid?',
    qcorrect: '5H',
    qbad1: '5C',
    qbad2: '5D',
    qbad3: 'PASS',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 663,
    qowner: 'NZBridge',
    qkey: 'NZBRKC12',
    qdetail: 'What is your bid?',
    qcorrect: '5C',
    qbad1: '5D',
    qbad2: '5H',
    qbad3: 'PASS',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 664,
    qowner: 'NZBridge',
    qkey: 'NZBRKC13',
    qdetail: 'What is your bid?',
    qcorrect: '5H',
    qbad1: '5D',
    qbad2: '5S',
    qbad3: '6H',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 665,
    qowner: 'NZBridge',
    qkey: 'NZBRKC14',
    qdetail: 'What is your bid?',
    qcorrect: '5H',
    qbad1: '5D',
    qbad2: '5S',
    qbad3: '6H',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 666,
    qowner: 'NZBridge',
    qkey: 'NZBRKC15',
    qdetail: 'What is your bid?',
    qcorrect: '5D',
    qbad1: '5H',
    qbad2: '5S',
    qbad3: '6H',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  },
  {
    qid: 667,
    qowner: 'NZBridge',
    qkey: 'NZBRKC16',
    qdetail: 'What is your bid?',
    qcorrect: '6H',
    qbad1: '5H',
    qbad2: '5D',
    qbad3: '5NT',
    qgroup1: 'NZBINT13',
    qgroup2: 'None',
    qgroup3: 'None',
    qrefs: ['NZBINT13N', 'NZBINT13Q']
  }
]
